<template>
  <div class="MSG_chat_body MSG_chat_body1 flex fdc jc-e" :class="{ MSG_chat_selectBox: selectInfo.Visible }">
    <!-- 好友列表 -->
    <div class="MSG_chat_container">
      <!-- 好友聊天内容 -->
      <div class="MSG_chat_content_box flex fdc" @click="closeClick" v-loading="loading1">
        <nav>
          <div class="Top_box flex aic jc-sb">
            <div class="flex aic" style="width: calc(100% - 60px)">
              <div class="svg_div flex aic jc-c" @click="backFriends" v-if="SessionList.length > 1 || unreadCount">
                <i class="iconfont icon-xiaoxiliebiao fff" style="font-size: 26px"></i>
              </div>
              <template v-if="dialogueInfo.type == 1">
                <div class="imgDiv">
                  <svg class="sr-only">
                    <clipPath id="mask__small-member2" clipPathUnits="objectBoundingBox">
                      <path
                        d="M1,0 H0 V1 H0.752 C0.701,0.949,0.669,0.878,0.669,0.8 C0.669,0.645,0.795,0.519,0.95,0.519 C0.967,0.519,0.984,0.52,1,0.523 V0" />
                    </clipPath>
                  </svg>
                  <el-image :src="dialogueInfo.HeadPhotoUrl" fit="cover">
                    <template #error>
                      <div class="image-slot">
                        <img src="https://im.files99.com/default/user.png" class="w100p h100p" />
                      </div>
                    </template>
                  </el-image>
                  <span class="avatar__presence1" v-if="dialogueInfo.isOnline"></span>
                  <span class="avatar__presence2" v-else></span>
                </div>
                <h4 @mouseenter="getWidth($event)" v-if="!loading1">
                  {{ dialogueInfo.nickname || "Chatbot Customer Service" }}
                </h4>
              </template>
              <template v-if="dialogueInfo.type == 2">
                <div class="channelDiv flex aic" @click="viewChanneldetails">
                  <span>#</span>
                  <el-tooltip class="bottom" effect="dark" :content="dialogueInfo.group_name" placement="top-start"
                    :disabled="isShowTooltip">
                    <p @mouseenter="getWidth($event)">
                      {{ dialogueInfo.group_name }}
                    </p>
                  </el-tooltip>
                  <el-icon class="ml-5" style="margin-top: 2px">
                    <ArrowDownBold />
                  </el-icon>
                </div>
              </template>
            </div>
          </div>
        </nav>
        <div class="MessageList scroll" ref="view_body" style="flex: 1" @scroll="scrollMessageList">
          <div class="message_list_item" v-for="(item, index) in MessageList" :key="item.id" :class="{
            hideUserprofilepicture: !showUserprofilepicture(item, index),
          }" :id="item.id">
            <div class="message_box flex" v-if="item.creator_id != userInfo.user_uid"
              :class="{ activeMessageItem: item.id == activeMessageId }">
              <div class="Userprofilepicture">
                <el-image :src="item.user_avatar_file_name" fit="cover">
                  <template #error>
                    <div class="image-slot">
                      <img src="../assets/image/logo-salesdeep.png" class="w100p h100p">
                    </div>
                  </template>
                </el-image>
              </div>
              <div class="messageContent">
                <p class="pl-10 mb-5">{{ item.creator_name }}</p>
                <template v-if="'Maincontent' in item">
                  <div class="messageWrap messageWrap1">
                    <div class="replyMessageBox">
                      <div class="flex aic jc-sb replyMessageInfo">
                        <p>
                          <span>{{ item.Maincreator_name }}</span>
                          <span class="timestamp1">{{
                            item.Maincreate_time
                          }}</span>
                        </p>
                        <svg t="1720864287566" class="icon" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="4256" width="22" height="22"
                          @click="GoMainMsg(item)">
                          <path
                            d="M128 128l768 0 0 89.6-768 0 0-89.6ZM732.288 496 555.7888 309.8624c-10.9504-11.2064-26.4128-18.4896-43.7888-18.4896s-32.832 7.2832-43.6032 18.6048L291.5264 495.8656c-9.2288 10.0224-15.1104 22.9696-15.1104 37.3248 0 30.816 26.3808 55.8016 58.8992 55.8016 0.4544 0 0.896-0.0576 1.344-0.0704l0 0.352L416 589.2736 416 896l192 0L608 589.2736l77.1904 0 0-0.448c1.1648 0.064 2.3104 0.1792 3.5008 0.1792 32.5248 0 58.8992-24.992 58.8992-55.8144C747.5904 518.8352 741.7024 505.8944 732.288 496z"
                            fill="#2e475d" p-id="4257" />
                        </svg>
                      </div>
                      <div v-html="item.Maincontent" class="htmlDiv" v-if="!item.obj_type && item.content"></div>
                      <div v-if="item.obj_type && item.obj_val" class="ObjPopupBox">
                        <div class="ObjPopupInfo">
                          <p>{{ item.obj_type1 }}</p>
                        </div>
                        <ObjPopup :ObjPopupData="{
                          type: item.obj_type,
                          data: JSON.parse(item.obj_val),
                          create_time: item.create_time,
                          id: item.id,
                        }" :showDetails="true" />
                      </div>
                      <replyMessageShowFile class="replyMessageShowFileBox" :file="item" v-if="item.Mainfile_path" />
                    </div>
                    <div class="htmlDiv" v-html="item.content"></div>
                    <showMessageFile :file="item" v-if="item.file_path" />
                  </div>
                </template>
                <template v-if="!('Maincontent' in item)">
                  <template v-if="item.obj_type && item.obj_val">
                    <div class="ObjPopupInfo">
                      <p class="mb-5">{{ item.obj_type1 }}</p>
                    </div>
                    <ObjPopup :ObjPopupData="{
                      type: item.obj_type,
                      data: JSON.parse(item.obj_val),
                      create_time: item.create_time,
                      id: item.id,
                    }" :showDetails="true" />
                  </template>
                  <template v-else>
                    <div class="messageWrap" v-if="!item.file_path">
                      <div class="htmlDiv" v-html="item.content"></div>
                    </div>
                    <showMessageFile :file="item" v-if="item.file_path" />
                  </template>
                </template>
                <!-- :class="{hidetimestamp:!showtimestamp(item,index)}" -->
                <span class="timestamp">{{
                  getupdate_time(item.create_time)
                }}</span>
              </div>
            </div>
            <div class="creator_message flex jc-e" v-if="item.creator_id == userInfo.user_uid"
              :class="{ activeMessageItem1: item.id == activeMessageId }">
              <div class="messageContent">
                <p class="pl-10 mb-5">{{ item.creator_name }}</p>
                <template v-if="'Maincontent' in item">
                  <div class="messageWrap messageWrap1">
                    <div class="replyMessageBox replyMessageBox1">
                      <div class="flex aic jc-sb replyMessageInfo">
                        <p>
                          <span>{{ item.Maincreator_name }}</span>
                          <span class="timestamp1">{{
                            item.Maincreate_time
                          }}</span>
                        </p>
                        <svg t="1720864287566" class="icon" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="4256" width="22" height="22"
                          @click="GoMainMsg(item)">
                          <path
                            d="M128 128l768 0 0 89.6-768 0 0-89.6ZM732.288 496 555.7888 309.8624c-10.9504-11.2064-26.4128-18.4896-43.7888-18.4896s-32.832 7.2832-43.6032 18.6048L291.5264 495.8656c-9.2288 10.0224-15.1104 22.9696-15.1104 37.3248 0 30.816 26.3808 55.8016 58.8992 55.8016 0.4544 0 0.896-0.0576 1.344-0.0704l0 0.352L416 589.2736 416 896l192 0L608 589.2736l77.1904 0 0-0.448c1.1648 0.064 2.3104 0.1792 3.5008 0.1792 32.5248 0 58.8992-24.992 58.8992-55.8144C747.5904 518.8352 741.7024 505.8944 732.288 496z"
                            fill="#2e475d" p-id="4257" />
                        </svg>
                      </div>
                      <div v-html="item.Maincontent" class="htmlDiv" v-if="!item.obj_type && item.content"></div>
                      <div v-if="item.obj_type && item.obj_val" class="ObjPopupBox">
                        <div class="ObjPopupInfo">
                          <p>{{ item.obj_type1 }}</p>
                        </div>
                        <ObjPopup :ObjPopupData="{
                          type: item.obj_type,
                          data: JSON.parse(item.obj_val),
                          create_time: item.create_time,
                          id: item.id,
                        }" :showDetails="true" />
                      </div>
                      <replyMessageShowFile class="replyMessageShowFileBox" :file="item" v-if="item.Mainfile_path" />
                    </div>
                    <div class="htmlDiv" v-html="item.content"></div>
                    <showMessageFile :file="item" v-if="item.file_path" />
                  </div>
                </template>
                <template v-if="!('Maincontent' in item)">
                  <template v-if="item.obj_type && item.obj_val">
                    <div class="ObjPopupInfo">
                      <p class="mb-5">{{ item.obj_type1 }}</p>
                    </div>
                    <ObjPopup :ObjPopupData="{
                      type: item.obj_type,
                      data: JSON.parse(item.obj_val),
                      create_time: item.create_time,
                      id: item.id,
                    }" :showDetails="true" />
                  </template>
                  <template v-else>
                    <div class="messageWrap" v-if="!item.file_path">
                      <div class="htmlDiv" v-html="item.content"></div>
                    </div>
                    <showMessageFile :file="item" v-if="item.file_path" />
                  </template>
                </template>
                <span class="timestamp">{{
                  getupdate_time(item.create_time)
                }}</span>
              </div>
            </div>
            <div class="message_unread" v-if="!item.isRead">
              <div class="message_unread_divider"></div>
              <span class="text">{{ $t("slack.newMessage") }}</span>
              <div class="message_unread_divider"></div>
            </div>
          </div>
        </div>
        <div class="backBox" v-if="ShowIcon">
          <div class="backTopBox" @click="backtop">
            <el-icon>
              <CaretTop />
            </el-icon>
          </div>
          <div class="backNewMsgBox" @click="backNewMsg" v-if="
            Messagetip[dialogueInfo.id] || Messagetip[dialogueInfo.group_id]
          ">
            <el-icon>
              <CaretTop />
            </el-icon>
            <div class="backtop-txt">{{ $t("slack.newMessage") }}</div>
          </div>
          <div class="backBottomBox" @click="backbottom" v-else>
            <el-icon>
              <CaretBottom />
            </el-icon>
          </div>
        </div>
        <!-- 非托管店铺客户聊天框 -->
        <div class="mt-20 mb-20 flex ml-15 cp" v-if="showPlatformIntervention">
          <div class="PlatformIntervention flex">
            <i class="iconfont icon-jiaru f16" style="color: #3370ff"></i>
            <p class="ml-10" @click="platformInterventionEvent">
              Platform Intervention
            </p>
          </div>
        </div>
        <div class="footer">
          <div class="FileBox" v-if="saveFile.file_path">
            <showUploadFile :file="saveFile" />
            <div class="loading-icon" v-loading="saveFile.isUpload" v-if="saveFile.isUpload"></div>
            <button class="elIconBtn flex aic jc-c" v-if="!saveFile.isUpload">
              <el-icon @click.stop="removeFile">
                <Close />
              </el-icon>
            </button>
          </div>
          <div class="sendMessageBox flex aic" :class="{ noBordersend: saveFile.file_path }">
            <!-- <el-input v-model="MessageText" @keydown.enter="sendMessage" ref="MsgInp" /> -->
            <div contenteditable="true" ref="MsgInp" :placeholder="$t('slack.Writemessage')" class="contentDiv"
              @input="inpuContent" @keydown.enter.exact.prevent="sendMessage"
              @keydown.enter.shift.exact.prevent="KeyEvent" @keydown.enter.ctrl.exact.prevent="KeyEvent" :style="{
                width:
                  dialogueInfo.type == 1 && !Isvisitor
                    ? 'calc(100% - 110px)'
                    : 'calc(100% - 80px)',
              }"></div>
            <p class="WritemessageText" v-if="!MessageText">
              {{ $t("slack.Writemessage") }}
            </p>
            <!-- <p class="WritemessageText" v-if="MessageText">{{ MessageText }}</p> -->
            <el-dropdown :placement="top - start" trigger="click" :teleported="false"
              v-if="dialogueInfo.type == 1 && !Isvisitor">
              <el-button class="selectObjBtn flex aic jc-c">
                <svg t="1719891968011" class="icon" viewBox="0 0 1433 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="6226" width="200" height="200">
                  <path d="M0 0h1433.6v204.8H0z m204.8 409.6h1024v204.8H204.8z m204.8 409.6h614.4v204.8H409.6z"
                    p-id="6227" />
                </svg>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="(item, index) in showTypeList" :key="index"
                    @click.native="changeTypeClick(item)">{{ item.text }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>

            <el-upload action :show-file-list="false" :http-request="uploadFile" style="display: inline-block">
              <el-button class="uploadBtn flex aic jc-c" :class="{ saveFileBtnActive: saveFile.file_path == '' }"
                :disabled="saveFile.file_path != ''">
                <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <path
                      d="M16.233 8.738c.564-.502.564-1.317 0-1.818-.564-.503-1.477-.503-2.04 0l-7.128 6.35c-1.374 1.223-1.374 3.213 0 4.436.686.612 1.587.918 2.49.918.9 0 1.802-.306 2.489-.918l10.318-9.193h.001c2.183-1.946 2.183-5.11 0-7.055-2.181-1.944-5.733-1.944-7.918 0l-12.2 10.87c-2.993 2.667-2.993 7.006 0 9.673C3.742 23.334 5.707 24 7.673 24c1.965 0 3.93-.666 5.427-2l9.01-8.027c.563-.501.563-1.316 0-1.818-.564-.503-1.478-.503-2.042 0l-9.009 8.027c-1.867 1.664-4.906 1.663-6.773 0-1.867-1.664-1.867-4.37 0-6.035l12.2-10.869c1.058-.944 2.779-.943 3.836-.001s1.057 2.475 0 3.417h-.002l-10.317 9.194c-.249.22-.651.22-.897 0-.248-.22-.248-.58 0-.8l7.127-6.35z"
                      id="attach__a" />
                  </defs>
                  <use xlink:href="#attach__a" fill-rule="evenodd" />
                </svg>
              </el-button>
            </el-upload>
            <el-button class="sendBtn flex aic jc-c" :class="{
              sendBtnActive:
                MessageText ||
                (saveFile.file_path != '' && !saveFile.isUpload),
            }" @click="sendMessage" :disabled="MessageText == '' && saveFile.file_path == ''">
              <svg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                  <path
                    d="M21.158.222L2.568 11.815c-.8.498-.749 1.215.113 1.591l4.406 1.923 10.395-9.903c1.377-1.296 1.569-1.119.426.395L8.254 18.215v4.927c0 .953.5 1.141 1.113.418l4.473-5.282 5.055 2.207c.861.376 1.643-.092 1.736-1.04l1.81-18.404c.094-.949-.484-1.317-1.283-.819"
                    id="send__a" />
                </defs>
                <use xlink:href="#send__a" fill-rule="evenodd" />
              </svg>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 创建频道 -->
    <createChannel />
    <!-- 频道详情 -->
    <channelDetails />
    <!-- 修改频道描述 -->
    <editDes />
    <!-- 添加好友 -->
    <addUser />
    <!-- 查看对象详情 -->
    <template v-if="showDetail">
      <ObjPopupdetail />
    </template>
    <!-- 查看对象弹窗 -->
    <el-dialog v-model="selectInfo.Visible" class="slack_selectVisible" :close-on-click-modal="false"
      :before-close="selectCancel" :style="selectInfo.getStyle">
      <div class="headerBox flex aic jc-e">
        <el-icon :size="16" @click="selectCancel">
          <Close />
        </el-icon>
      </div>
      <MyRFQ v-if="selectInfo.type == 'MyRFQ'" />
      <ContactsRFQ v-if="selectInfo.type == 'ContactsRFQ'" />
      <PersonalRFQ v-if="selectInfo.type == 'PersonalRFQ'" />
      <PublicRFQ v-if="selectInfo.type == 'PublicRFQ'" />
      <MyQtn v-if="selectInfo.type == 'MyQTN' && userType == 4" />
      <InternalMyQtn v-if="selectInfo.type == 'MyQTN' && userType != 4" />
      <PurchaseQTN v-if="selectInfo.type == 'PurchaseQTN' && userType != 4" />
      <OutPurchaseQTN v-if="selectInfo.type == 'PurchaseQTN' && userType == 4" />
      <ContactsQTN v-if="selectInfo.type == 'ContactQTN'" />
      <salesOrder v-if="selectInfo.type == 'SaleOrder' && userType != 4" />
      <salesOrderClient v-if="selectInfo.type == 'SaleOrder' && userType == 4" />
      <purchaseOrder v-if="selectInfo.type == 'PurchaseOrder' && userType != 4" />
      <purchaseOrderClient v-if="selectInfo.type == 'PurchaseOrder' && userType == 4" />
      <template #footer>
        <div class="selectedBox">
          <div v-show="selectData">
            <p v-if="selectInfo.type == 'MyRFQ'" class="mb-15" style="color: #409eff">
              {{ selectData.inquiry_id }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'ContactsRFQ'" class="mb-15" style="color: #409eff">
              {{ selectData.inquiry_id }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'PersonalRFQ'" class="mb-15" style="color: #409eff">
              {{ selectData.inquiry_id }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'PublicRFQ'" class="mb-15" style="color: #409eff">
              {{ selectData.inquiry_id }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'MyQTN'" class="mb-15" style="color: #409eff">
              {{ selectData.inquiry_id }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'PurchaseQTN'" class="mb-15" style="color: #409eff">
              {{ selectData.inquiry_id }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'ContactQTN'" class="mb-15" style="color: #409eff">
              {{ selectData.inquiry_id }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'SaleOrder'" class="mb-15" style="color: #409eff">
              {{ selectData.PI_name }}
              Selected!
            </p>
            <p v-if="selectInfo.type == 'PurchaseOrder' && userType != 4" class="mb-15" style="color: #409eff">
              {{ selectData.Purchaseordername }} Selected!
            </p>
            <p v-if="selectInfo.type == 'PurchaseOrder' && userType == 4" class="mb-15" style="color: #409eff">
              {{ selectData.order_number }} Selected!
            </p>
          </div>
        </div>
        <span class="dialog-footer">
          <el-button @click="selectCancel">{{ $t("slack.Cancel") }}</el-button>
          <el-button type="primary" @click="selectConfirm">{{
            $t("slack.Confirm")
          }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
  debounce,
  parseTime,
  getRealJsonData,
  extend,
  getupdate_time,
  getupdate_time1,
  getWebType,
  IsRefresh
} from "./utils/index";
import createChannel from "./components/createChannel.vue";
import channelDetails from "./components/channelDetails.vue";
import addUser from "./components/addUser.vue";
import editDes from "./components/editDes.vue";
import { shallowRef } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  Close,
  Search,
  ArrowDownBold,
  Plus,
  CloseBold,
  CaretTop,
  CaretBottom,
} from "@element-plus/icons-vue";
import * as $axios from "./api/index";
import getApiUrl from "./api/api.js";
import { nextTick } from "vue";
import showUploadFile from "./showUploadFile.vue";
import showMessageFile from "./showMessageFile.vue";
import replyMessageShowFile from "./replyMessageShowFile.vue";
import ObjPopup from "./components/ObjPopup/index.vue";
import ObjPopupdetail from "./components/ObjPopup/detail.vue";
import PersonalRFQ from "./components/project/rfq/children/Personal.vue";
import MyRFQ from "./components/project/rfq/children/MyRFQ.vue";
import ContactsRFQ from "./components/project/rfq/children/ContactsRFQ.vue";
import PublicRFQ from "./components/project/rfq/children/Public.vue";
import salesOrder from "./components/project/order/children/salesOrder.vue";
import salesOrderClient from "./components/project/order/children/salesOrderClient.vue";
import PurchaseQTN from "./components/project/qtn/children/Purchase.vue";
import OutPurchaseQTN from "./components/project/qtn/children/OutPurchase.vue";
import MyQtn from "./components/project/qtn/children/MyQtn.vue";
import InternalMyQtn from "./components/project/qtn/children/InternalMyQtn.vue";
import ContactsQTN from "./components/project/qtn/children/Contacts.vue";
import purchaseOrder from "./components/project/order/children/purchaseOrder.vue";
import purchaseOrderClient from "./components/project/order/children/purchaseOrderClient.vue";
import * as Rfq from "@/api/apiRfq/index.js";
import * as user from "@/api/apiSale/user.js";
import * as Order from "@/api/apiPayOrder/index.js";
import { Kernaldec } from "@/hooks/useDecrypt.js";
import { mapState } from "pinia";
import { HomeStore } from "./index.js";
import { useDemoStore } from "@/pinia/index.js";
import axios from "axios";
import axios1 from "axios";
import { useI18n } from "vue-i18n"; //国际化
import i18n from "@/assets/lang";
import { setStore, getStore, getAllStore } from "./utils/store";
export default {
  components: {
    showUploadFile,
    showMessageFile,
    replyMessageShowFile,
    channelDetails,
    addUser,
    editDes,
    createChannel,
    ObjPopupdetail,
    ObjPopup,
    MyRFQ,
    ContactsRFQ,
    PersonalRFQ,
    PublicRFQ,
    salesOrder,
    salesOrderClient,
    purchaseOrder,
    purchaseOrderClient,
    PurchaseQTN,
    OutPurchaseQTN,
    ContactsQTN,
    MyQtn,
    InternalMyQtn,
  },
  data() {
    return {
      Close: shallowRef(),
      Search: shallowRef(),
      ArrowDownBold: shallowRef(),
      Plus: shallowRef(),
      CaretTop: shallowRef(),
      CaretBottom: shallowRef(),
      SessionList: [], //保存会话列表
      showType: 2, //显示的类型
      loading: false, //loading框
      MessageList: [], //返回当前聊天的消息
      MessageText: "", //要发送的消息
      getupdate_time,
      saveFile: {
        file_path: "",
        file_name: "空文本.txt",
        suffixName: "",
        type: "",
        isUpload: true,
        cancel: null,
      }, //保存上传的文件信息
      inpuContentHeight: "40",
      timer: null, //定时更新消息的时间
      unreadCount: 0, //未读消息总量
      sessionObjectKeyWord: "", //会话对象的关键字搜索
      friendList: [], //显示的好友列表，
      showchannelList: [], //显示的频道列表
      showrfqGroupList: [], //显示的询盘频道
      showSessionListVisible: false, //显示联系人下拉列表
      showTypeList: [], //显示发送对象的选项
      selectInfo: {
        Visible: false,
        type: "RFQ",
        getStyle: "",
      },
      Isvisitor: false, //判断是否为访客
      engineer_id: "", //工程师ID
      vendor_id: "", //海外供应商
      sales_id: "", //接口传过来的数据
      user_host: "", //自己所在的服务器
      Timer: "",
      Timer1: "",
      saveOldId: "", //保存之前的Id
      saveBackId: "", //保存返回会话页面的Id
      owner_info_user_uid: "", //客户的销售owner_id
      isShowTooltip: false, //是否显示
      chatUserId: "", //官网聊天的用户Id
      website_id: "", //站点ID
      website_name: "", //站点名称
      activeMessageId: "",
      ShowIcon: false, //是否显示按钮
      IsFirstOpen: false, //是否第一次调用第一次未读私信消息
      IsFirstOpen1: false, //是否第一次调用未读频道消息
      activeUnRead: 0, //当前聊天对象是否有未读消息
      owner_id_str: "", //站点的管理人
      ChatClose: true, //是否关闭了聊天窗口
      chatIds: [],
      visitor_id: "", //传给后端的
      IsbindTourist: false, //是否触发绑定游客操作
      showPlatformIntervention: false, //是否显示平台加入
      provide_management_type: 2,
    };
  },
  computed: {
    ...mapState(HomeStore, [
      "userInfo",
      "friends",
      "token",
      "chatMessageList",
      "IsSendMessage",
      "IspromptMessage",
      "channelList",
      "rfqGroupList",
      "IsPrivatechat",
      "IsDelPrivatechat",
      "showDetail",
      "selectData",
      "friend_host",
      "visibilityState",
      "Messagetip",
    ]),
    dialogueInfo() {
      return HomeStore().setting.dialogueInfo;
    },
    loading1() {
      return HomeStore().setting.loading;
    },
    SessionListNum() {
      return (
        HomeStore().friends.length +
        HomeStore().channelList.length +
        this.showrfqGroupList.length
      );
    },
    userType() {
      return useDemoStore().type;
    },
  },
  watch: {
    //监听是否在当前窗口
    visibilityState(val) {
      if (val && !this.ChatClose) {
        this.setMessageState(this.dialogueInfo);
      }
    },
    ChatClose(val) {
      if (!val) {
        if (this.website_id) {
          this.setMessageState(this.dialogueInfo);
          this.assignEvent()
        }
      }
    },
    //监听消息列表
    chatMessageList: {
      handler: function () {
        this.GetunreadCount();
        this.getSessionChat();
        // this.getLastMessage();
      },
      deep: true,
      immediate: true,
    },
    MessageList: {
      handler: function () {
        this.GetunreadCount();
        this.getSessionChat();
        // this.getLastMessage();
      },
      deep: true,
      immediate: true,
    },
    //是否有新消息
    IsSendMessage(val) {
      if (val) {
        this.newMessage();
      }
    },
  },
  mounted() {
    IsRefresh()
    this.clearPinia();
    this.clearTimer();
    HomeStore().setting.loading = true;
    HomeStore().setting.loading1 = true;
    HomeStore().menuIndex = -1;
    this.Close = Close;
    this.Search = Search;
    this.ArrowDownBold = ArrowDownBold;
    this.Plus = Plus;
    this.CaretTop = CaretTop;
    this.CaretBottom = CaretBottom;
    let dom = document.getElementsByClassName("MSG_chat_container")[0];
    dom.onclick = () => {
      this.showSessionListVisible = false;
    };
    const { locale } = useI18n();
    this.loading = true;
    // 获取速度最快的
    //监听站点发来的信息
    window.addEventListener("message", (e) => {
      let data = e.data;
      console.log(e, HomeStore().token, "接收的消息");
      if ("token" in data) {
        if ("ChatClose" in data) {
          this.ChatClose = data.ChatClose;
        }
        if ("codeKey" in data) {
          useDemoStore().codeKey = data.codeKey;
        }
        if ("serve" in data) {
          useDemoStore().lang = data.lang == 'zh-CN' ? 'zh-cn' : "en-us"
          HomeStore().lang = data.lang == 'zh-CN' ? 'zh-cn' : "en-us"
          locale.value = data.lang == 'zh-CN' ? 'zh-cn' : "en-us"
          this.setServe(data.serve);
        }
        if ("owner_id_str" in data) {
          this.owner_id_str = data.owner_id_str;
        }
        if ("visitor_id" in data) {
          this.visitor_id = data.visitor_id;
        }
        if ("visitor_id" in data) {
          this.provide_management_type = data.provide_management_type;
        }
        if ("website_id" in data) {
          this.website_id = data.website_id;
          this.website_name = data.website_name;
          setStore({
            name: "website_id",
            content: data.website_id,
          });
        }
        if (!this.IsFirstOpen) {
          // if ("sales_id" in data) {
          //   this.sales_id = data.sales_id;
          // }
          if ("engineer_id" in data) {
            this.engineer_id = data.engineer_id;
          }
          if ("vendor_id" in data) {
            this.vendor_id = data.vendor_id;
          }
          HomeStore().setuserInfo({
            userId: data.userId,
            user_id: data.user_id,
            user_uid: data.user_id,
          });
          this.Isvisitor = false;
          this.IsFirstOpen = true;
          HomeStore().setToken(data.token);
          useDemoStore().changeToken(data.token);
          this.IsbindTourist = true;
          setTimeout(() => {
            if (data.website_id) {
              this.website_id = data.website_id;
              this.website_name = data.website_name;
              setStore({
                name: "website_id",
                content: data.website_id,
              });
            }
            this.setBasicInfo();
          }, 500);
        }
        this.IsFirstOpen = true;
      } else {
        if ("ChatClose" in data) {
          this.ChatClose = data.ChatClose;
        }
        if ("owner_id_str" in data) {
          this.owner_id_str = data.owner_id_str;
        }
        if ("serve" in data) {
          useDemoStore().lang = data.lang == 'zh-CN' ? 'zh-cn' : "en-us"
          HomeStore().lang = data.lang == 'zh-CN' ? 'zh-cn' : "en-us"
          locale.value = data.lang == 'zh-CN' ? 'zh-cn' : "en-us"
          this.setServe(data.serve);
        }
        if ("visitor_id" in data) {
          this.visitor_id = data.visitor_id;
        }
        if ("website_id" in data) {
          this.website_id = data.website_id;
          this.website_name = data.website_name;
          setStore({
            name: "website_id",
            content: data.website_id,
          });
        }
        if ("engineer_id" in data) {
          this.engineer_id = data.engineer_id;
        }
        if ("vendor_id" in data) {
          this.vendor_id = data.vendor_id;
        }
        if ("chatUserId" in data) {
          this.chatUserId = data.chatUserId;
          this.website_id = 8888;
          this.website_name = "official website";
        }
        if ("Isvisitor" in data) {
          this.Isvisitor = true;
          if (!this.IsFirstOpen) {
            HomeStore().setToken("");
            useDemoStore().changeToken("");
            setTimeout(() => {
              this.setBasicInfo();
            }, 500);
          }
          this.IsFirstOpen = true;
        }
        if ("detoken" in data) {
          HomeStore().setToken("");
          useDemoStore().changeToken("");
        }
      }
    });
    var child = document.querySelector(".sendMessageBox ");
    // 为子元素添加事件监听器
    child.addEventListener(
      "mousewheel",
      function (event) {
        event.preventDefault();
      },
      { passive: false }
    );
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState == "hidden") {
        HomeStore().visibilityState = false;
      } else if (document.visibilityState == "visible") {
        HomeStore().visibilityState = true;
      }
    });
    console.log("初始化");
  },
  methods: {
    getWidth(event) {
      if (event.target.scrollWidth > event.target.clientWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },
    //前往主消息
    GoMainMsg(item) {
      let view = this.$refs.view_body;
      if (!document.getElementById(item.MainId)) {
        if (useDemoStore().lang == "en-us") {
          ElMessage({
            type: "error",
            message: "The original message does not exist.",
          });
        } else {
          ElMessage({
            type: "error",
            message: "原消息不存在.",
          });
        }
        return;
      }
      setTimeout(() => {
        view.scrollTop = document.getElementById(item.MainId).offsetTop - 210;
      }, 500);
      this.activeMessageId = item.MainId;
      setTimeout(() => {
        this.activeMessageId = -1;
      }, 2000);
    },
    //设置服务器
    setServe(val) {
      let serve = val;
      if (val == "us") {
        serve = "usWest";
      }
      if (val == "use") {
        serve = "usEst";
      }
      let store = useDemoStore();
      store.changeServer(serve);
    },
    //设置未读消息的样式
    GetunreadStyle(val) {
      if (val >= 10) {
        return {
          width: "20px",
          height: "20px",
        };
      }
      if (val >= 99) {
        return {
          width: "24px",
          height: "24px",
        };
      }
    },
    //邀请平台介入
    platformInterventionEvent() {
      $axios
        .platformIntervention({
          website_id: this.website_id,
          vendor_id: this.vendor_id,
          user_uid: this.dialogueInfo.id,
        })
        .then((res) => {
          this.showPlatformIntervention = false;
          HomeStore().setConfig("dialogueInfo", {
            type: 2,
            group_id: res.data.group_id,
            group_name: "Platform Intervention",
          });
        });
    },
    //连接
    initWebSocket() {
      let baseURL = getApiUrl();
      let WebSocketURL = this.getWebSocketURL();
      HomeStore().socket = new WebSocket(`wss://${WebSocketURL}/socket`);
      HomeStore().baseURL = baseURL;
      HomeStore().socket.onopen = () => {
        console.log("socket onopen", HomeStore().socket);
        this.startTimer();
      };
      HomeStore().socket.onerror = (e) => {
        this.websocketOnError(e);
      };
      HomeStore().socket.onclose = (e) => {
        this.websocketOnError(e);
      };
      HomeStore().socket.onmessage = (e) => {
        let obj = getRealJsonData(e.data);
        if ("client_id" in obj) {
          HomeStore().client_id = obj.client_id;
          if (HomeStore().token) {
            $axios
              .bing({
                token: HomeStore().token,
                client_id: HomeStore().client_id,
              })
              .then((res) => {
                this.user_host = res.data.user_host;
              })
          }
        }
        if (HomeStore().client_id) {
          if ("msgtype" in obj) {
            if (obj.msgtype == "notify") {
              if (obj.sub_type == "shop_chat_transferred_leixiao") {
                if (obj.content.user_uid) {
                  HomeStore().setting.dialogueInfo.id = obj.content.user_uid;
                  HomeStore().setting.dialogueInfo.nickname =
                    obj.content.nickname;
                  HomeStore().setting.dialogueInfo.isOnline = obj.content.isOnline;
                  HomeStore().setting.dialogueInfo.HeadPhotoUrl = obj.content.profile_photo
                }
              }
            }
            if (obj.msgtype == "GroupChat" || obj.msgtype == "GroupForward") {
              obj.replyMessageList = [];
              if (obj.son) {
                obj.replyMessageList = obj.son;
              }
              if (obj.user_id == this.userInfo.user_uid) {
                let MsgIndex = this.MessageList.findIndex((item) => {
                  return item.id == obj.id;
                });
                if (MsgIndex == -1) {
                  obj.creator_id = obj.user_id;
                  obj.isRead = true;
                  obj.read = 1;
                  this.MessageList.push(obj);
                  HomeStore().IsSendMessage = true;
                }
              } else {
                if (HomeStore().visibilityState && !this.ChatClose) {
                  obj.isRead = true;
                  obj.read = 1;
                  $axios.groupread({
                    token: HomeStore().token,
                    group_id: obj.group_id,
                    readtype: "read",
                  });
                } else {
                  obj.read = 0;
                  HomeStore().IspromptMessage = true;
                }
                obj.creator_id = obj.user_id;
                this.MessageList.push(obj);
                HomeStore().IsSendMessage = true;
              }
            }
            if (obj.msgtype == "PrivateChat" || obj.msgtype == "Forward") {
              obj.replyMessageList = [];
              if (HomeStore().userInfo.user_uid == obj.creator_id) {
                let index1 = this.MessageList.findIndex((item) => {
                  return item.id == obj.id;
                });
                if (index1 != -1) {
                  return;
                }
                obj.isRead = true;
                obj.read = 1;
                if (obj.son) {
                  obj.replyMessageList = obj.son;
                }
                this.MessageList.push(obj);
                HomeStore().IsSendMessage = true;
              } else {
                let index1 = this.MessageList.findIndex((item) => {
                  return item.id == obj.id;
                });
                if (index1 != -1) {
                  return;
                }
                if (HomeStore().visibilityState && !this.ChatClose) {
                  $axios.websiteMsgread({
                    website_id: this.website_id,
                  });
                  obj.isRead = true;
                  obj.read = 1;
                } else {
                  obj.read = 0;
                  HomeStore().IspromptMessage = true;
                }
                this.MessageList.push(obj);
                HomeStore().IsSendMessage = true;
              }
            }
            if (obj.msgtype == "GroupReply") {
              if (HomeStore().chatMessageList[obj.yuannerong.group_id]) {
                let group_id = obj.yuannerong.group_id;
                obj.creator_id = obj.yuannerong.user_id;
                if (useDemoStore().lang != "zh-cn") {
                  obj.huifu.create_time = parseTime(
                    obj.huifu.time,
                    "{m}-{d}-{y} {h}:{i}:{s}"
                  );
                }
                let MessageIndex = this.MessageList.findIndex((item) => {
                  return item.id == obj.yuannerong.id;
                });
                if (MessageIndex != -1) {
                  this.MessageList[MessageIndex].replyMessageList.push(
                    obj.huifu
                  );
                }
                let MessageObj = extend(obj.huifu, true);
                if (obj.yuannerong.user_id != this.userInfo.user_uid) {
                  if (HomeStore().visibilityState && !this.ChatClose) {
                    $axios
                      .groupread({
                        token: HomeStore().token,
                        group_id: group_id,
                        readtype: "read",
                      })
                      .then(() => {
                        HomeStore().getunReadMsgCount();
                      });
                    MessageObj.read = 0;
                  } else {
                    MessageObj.read = 1;
                    MessageObj.isRead = true;
                  }
                }
                MessageObj.replyMessageList = [];
                MessageObj.creator_id = MessageObj.user_id;
                MessageObj.MainId =
                  HomeStore().chatMessageList[group_id][index].id;
                MessageObj.Maincontent =
                  HomeStore().chatMessageList[group_id][index].content;
                MessageObj.Maincreate_time =
                  HomeStore().chatMessageList[group_id][index].create_time;
                MessageObj.Maincreator_name =
                  HomeStore().chatMessageList[group_id][index].creator_name;
                if (
                  "obj_type" in HomeStore().chatMessageList[group_id][index]
                ) {
                  MessageObj.obj_type =
                    HomeStore().chatMessageList[group_id][index].obj_type;
                  MessageObj.obj_val =
                    HomeStore().chatMessageList[group_id][index].obj_val;
                }
                if (
                  "file_path" in HomeStore().chatMessageList[group_id][index]
                ) {
                  MessageObj.Mainfile_path =
                    HomeStore().chatMessageList[group_id][index].file_path;
                  MessageObj.Mainfile_name =
                    HomeStore().chatMessageList[group_id][index].file_name;
                  MessageObj.Mainmimetype =
                    HomeStore().chatMessageList[group_id][index].mimetype;
                }
                HomeStore().chatMessageList[group_id].push(MessageObj);
                this.MessageList.push(MessageObj);
                HomeStore().IsSendMessage = true;
              }
            }
            if (obj.msgtype == "Reply") {
              if (useDemoStore().lang != "zh-cn") {
                obj.huifu.create_time = parseTime(
                  obj.huifu.time,
                  "{m}-{d}-{y} {h}:{i}:{s}"
                );
              }
              let MessageIndex = this.MessageList.findIndex((item) => {
                return item.id == obj.yuannerong.id;
              });
              if (MessageIndex != -1) {
                this.MessageList[MessageIndex].replyMessageList.push(obj.huifu);
              }
              let MessageObj = extend(obj.huifu, true);
              if (obj.huifu.creator_id == this.userInfo.user_uid) {
                MessageObj.isRead = true;
                MessageObj.read = 1;
                $axios.websiteMsgread({
                  website_id: this.website_id,
                });
              } else {
                if (HomeStore().visibilityState && !this.ChatClose) {
                  MessageObj.isRead = true;
                  essageObj.read = 1;
                } else {
                  MessageObj.read = 0;
                }
              }
              MessageObj.replyMessageList = [];
              MessageObj.MainId = this.MessageList[MessageIndex].id;
              MessageObj.Maincontent = this.MessageList[MessageIndex].content;
              MessageObj.Maincreate_time =
                this.MessageList[MessageIndex].create_time;
              MessageObj.Maincreator_name =
                this.MessageList[MessageIndex].creator_name;
              if ("obj_type" in this.MessageList[MessageIndex]) {
                MessageObj.obj_type = this.MessageList[MessageIndex].obj_type;
                MessageObj.obj_val = this.MessageList[MessageIndex].obj_val;
              }
              if ("file_path" in this.MessageList[MessageIndex]) {
                MessageObj.Mainfile_path =
                  this.MessageList[MessageIndex].file_path;
                MessageObj.Mainfile_name =
                  this.MessageList[MessageIndex].file_name;
                MessageObj.Mainmimetype =
                  this.MessageList[MessageIndex].mimetype;
              }
              this.MessageList.push(MessageObj);
              HomeStore().IsSendMessage = true;
            }
            //删除好友
            if (obj.msgtype == "RemoveFriends") {
              if (HomeStore().userInfo.user_uid == obj.friend_id) {
                let index = HomeStore().friends.findIndex((item) => {
                  return item.user_uid == obj.user_uid;
                });
                if (index >= 0) {
                  // HomeStore().friends.splice(index, 1);
                  HomeStore().isError[HomeStore().friends[index].user_uid] = [];
                }
              }
            }
            //添加好友
            if (obj.msgtype == "AddFriends") {
              if (HomeStore().userInfo.user_uid == obj.friend_id) {
                HomeStore().isError[obj.user_info[0].user_uid] = "";
                let index = HomeStore().friends.findIndex((item) => {
                  return item.user_uid == obj.user_info[0].user_uid;
                });
                if (index >= 0) {
                  return;
                }
                let user = obj.user_info[0];
                user.receiver_name = user.nickname;
                user.HeadPhotoUrl = user.user_avatar_file_name;
                user.unread = 0;
                user.isOnline = 1;
                user.receiver_id = user.user_uid;
                HomeStore().friends.unshift(user);
                if (
                  HomeStore().menuIndex >
                  HomeStore().AsteriskList.length +
                  HomeStore().channelList.length +
                  HomeStore().conversationObjectList.length
                ) {
                  HomeStore().menuIndex += 1;
                }
                HomeStore().isNeedQuery[user.user_uid] = true;
                HomeStore().chatMessageList[user.user_uid] = [];
              }
            }
            //邀请人员加入频道
            if (obj.msgtype == "JoinGroup") {
              if (
                HomeStore().userInfo.user_uid == obj.touser_info[0].user_uid
              ) {
                obj.group_info.group_id = obj.group_info.id;
                obj.group_info.unread = 0;
                HomeStore().chatMessageList[obj.group_info.group_id] = [];
                HomeStore().isNeedQuery[obj.group_info.group_id] = true;
                HomeStore().isError[obj.touser_info[0].user_uid] = "";
                if (!obj.group_info.inquiry_id) {
                  let index = HomeStore().channelList.findIndex((item) => {
                    return item.group_id == obj.group_info.group_id;
                  });
                  if (index != -1) {
                    return;
                  }
                  HomeStore().channelList.unshift(obj.group_info);
                  if (
                    HomeStore().friends.length == 0 &&
                    HomeStore().channelList.length == 1
                  ) {
                  }
                }
                if (obj.group_info.inquiry_id) {
                }
                if (
                  HomeStore().menuIndex >
                  HomeStore().AsteriskList.length +
                  HomeStore().conversationObjectList.length
                ) {
                  if (
                    obj.group_info.inquiry_id &&
                    HomeStore().ShowChannelType == 2
                  ) {
                    HomeStore().menuIndex += 1;
                  }
                  if (
                    !obj.group_info.inquiry_id &&
                    HomeStore().ShowChannelType == 2
                  ) {
                    HomeStore().menuIndex += 1;
                  }
                }
                this.getgroupchat(obj.group_info);
              }
            }
            //解散频道
            if (obj.msgtype == "Exit") {
              if (HomeStore().userInfo.user_uid == obj.friend_id) {
              }
            }
            if (obj.msgtype == "DissolveGroup") {
              HomeStore().isError[obj.group_id] = [];
            }
            //移出频道
            if (obj.msgtype == "Remove") {
              if (HomeStore().userInfo.user_uid == obj.member) {
                HomeStore().isError[obj.group_id] = [];
              }
            }
            //修改频道名称
            if (obj.msgtype == "groupedit") {
              let index = HomeStore().channelList.findIndex((item) => {
                return item.group_id == obj.group_id;
              });
              if (index != -1) {
                HomeStore().channelList[index].group_name = obj.new_group_name;
                HomeStore().channelList[index].description =
                  obj.new_description;
              }
              if (index == -1) {
              }
              if (HomeStore().setting.dialogueInfo.type == 2) {
                if (HomeStore().setting.dialogueInfo.group_id == obj.group_id) {
                  HomeStore().setting.dialogueInfo.group_name =
                    obj.new_group_name;
                  HomeStore().setting.dialogueInfo.description =
                    obj.new_description;
                }
              }
            }
            //删除群聊消息
            if (obj.msgtype == "del_group_msg") {
              for (let i in HomeStore().chatMessageList) {
                HomeStore().chatMessageList[i].map((item, index) => {
                  if (item.id == obj.group_msg_id) {
                    HomeStore().chatMessageList[i].splice(index, 1);
                  }
                });
              }
            }
            //删除私信消息
            if (obj.msgtype == "del_private_msg") {
              for (let i in HomeStore().chatMessageList) {
                HomeStore().chatMessageList[i].map((item, index) => {
                  if (item.id == obj.private_msg_id) {
                    HomeStore().chatMessageList[i].splice(index, 1);
                  }
                });
              }
            }
          }
          if ("type" in obj) {
            setTimeout(() => {
              if (obj.type == "Offline") {
                let index = 0;
                index = HomeStore().friends.findIndex((item) => {
                  return item.receiver_name == obj.user;
                });
                HomeStore().AsteriskList.map((item) => {
                  if ("receiver_name" in item) {
                    if (item.receiver_name == obj.user) {
                      item.isOnline = 0;
                    }
                  }
                });
                if (index < 0) {
                  return;
                }
                HomeStore().friends[index].isOnline = 0;
                if (HomeStore().setting.dialogueInfo.type == 1) {
                  if (HomeStore().setting.dialogueInfo.nickname == obj.user) {
                    HomeStore().setting.dialogueInfo.isOnline = 0;
                  }
                }
              }
              if (obj.type == "Be Online") {
                let index = 0;
                if ("msgtype" in obj) {
                  if (HomeStore().userInfo.user_uid == obj.friend_id) {
                    index = HomeStore().friends.findIndex((item) => {
                      return item.receiver_name == obj.user_info[0].nickname;
                    });
                  } else {
                    index = HomeStore().friends.findIndex((item) => {
                      return item.receiver_name == obj.user;
                    });
                  }
                  HomeStore().AsteriskList.map((item) => {
                    if ("receiver_name" in item) {
                      if (item.receiver_name == obj.user_info[0].nickname) {
                        item.isOnline = 1;
                      }
                    }
                  });
                } else {
                  index = HomeStore().friends.findIndex((item) => {
                    return item.receiver_name == obj.user;
                  });
                  HomeStore().AsteriskList.map((item) => {
                    if ("receiver_name" in item) {
                      if (item.receiver_name == obj.user) {
                        item.isOnline = 1;
                      }
                    }
                  });
                }
                if (index < 0) {
                  return;
                }
                HomeStore().friends[index].isOnline = 1;
                if (HomeStore().setting.dialogueInfo.type == 1) {
                  if (HomeStore().setting.dialogueInfo.nickname == obj.user) {
                    HomeStore().setting.dialogueInfo.isOnline = 1;
                  }
                }
              }
            }, 500);
          }
        }
      };
    },
    startTimer() {
      clearInterval(this.timer);
      if (this.timer === null) {
        this.timer = setInterval(() => {
          this.send();
        }, 50000); // 一分钟请求一次
      }
    },
    send() {
      console.log("发送的心跳数据", JSON.stringify({ type: "ping" }));
      HomeStore().socket.send(JSON.stringify({ type: "ping" }));
    },
    //获取WebSocketurl
    getWebSocketURL() {
      const store = useDemoStore();
      let context = store.context;
      if (context == 0) {
        return "im.files99.com";
      } else if (context == 1) {
        if (store.server == "cn") {
          //中国
          return "cn-im-api-produce.files99.com";
        } else if (store.server == "de") {
          //德国
          return "de-im-api-produce.kernal.net";
        } else if (store.server == "usWest") {
          //美国西部
          return "us-im-api-produce.kernal.net";
        } else if (store.server == "usEst") {
          //美国东部
          return "use-im.salesdeep.com";
        } else if (store.server == "br") {
          //巴西
          return "br-im-api-produce.kernal.net";
        } else if (store.server == "sg") {
          //新加坡
          return "sg-im-api-produce.kernal.net";
        }
      } else if (context == 2) {
        if (store.server == "cn") {
          //中国
          return "cn-im-api-produce.files99.com";
        } else if (store.server == "de") {
          //德国
          return "de-im.salesdeep.com";
        } else if (store.server == "usWest") {
          //美国西部
          return "us-im.salesdeep.com";
        } else if (store.server == "usEst") {
          //美国东部
          return "use-im.salesdeep.com";
        } else if (store.server == "br") {
          //巴西
          return "br-im.salesdeep.com";
        } else if (store.server == "sg") {
          //新加坡
          return "sg-im.salesdeep.com";
        }
      }
    },
    websocketOnError: debounce(function (val) {
      setTimeout(() => {
        this.initWebSocket();
      }, 10000);
    }, 1000),
    //初始化
    init() {
      if (this.sales_id) {
        this.chatIds.push(this.sales_id);
      }
      if (this.engineer_id) {
        this.chatIds.push(this.engineer_id);
      }
      if (this.chatUserId) {
        this.chatIds.push(this.chatUserId);
      }
      this.getAllInfo();
    },
    //获取好友列表、频道列表
    getAllInfo() {
      let userInfo = JSON.parse(window.localStorage.getItem("erp"));
      HomeStore().setuserInfo(userInfo);
      setTimeout(() => {
        let userInfo = JSON.parse(window.localStorage.getItem("erp"));
        HomeStore().setuserInfo(userInfo);
      }, 500);
      $axios
        .showfriends({
          token: HomeStore().token,
        })
        .then((res) => {
          let chatList = res.data;
          this.chatIds.map((item) => {
            chatList.push({
              user_uid: item,
              receiver_name: item,
              user_avatar_file_name: "https://im.files99.com/default/user.png",
              isOnline: true,
              unread: 0,
            });
          });
          chatList.map((item) => {
            item.user_avatar_file_name = item.friend_avatar_file_name;
            HomeStore().chatMessageList[item.user_uid] = [];
            HomeStore().isNeedQuery[item.user_uid] = true;
            if (!item.user_avatar_file_name) {
              item.user_avatar_file_name =
                "https://im.files99.com/default/user.png";
            }
          });
          HomeStore().friends = extend(res.data, true).sort(
            this.compareByOnline
          );
          HomeStore().friends = extend(res.data, true).sort(this.sortByUnRead);
          this.friendList = extend(HomeStore().friends, true);
          this.getChatMessageList(this.dialogueInfo);
          this.showType = 2;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    compareByOnline(a, b) {
      const bandA = a.isOnline;
      const bandB = b.isOnline;
      let comparison = 0;
      if (bandA) {
        comparison = -1;
      } else if (!bandB) {
        comparison = 1;
      }
      return comparison;
    },
    //根据未读消息数进行排序
    sortByUnRead(a, b) {
      // 使用 toUpperCase() 忽略字符大小写
      const bandA = a.unread;
      const bandB = b.unread;
      let comparison = 0;
      if (bandA > bandB) {
        comparison = -1;
      } else if (bandA < bandB) {
        comparison = 1;
      }
      return comparison;
    },
    //设置用户信息
    setBasicInfo() {
      let token = JSON.parse(window.localStorage.getItem("token"));
      let userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
      if (token) {
        this.initWebSocket();
        HomeStore().setuserInfo(userInfo);
        HomeStore().setToken(token);
        useDemoStore().changeToken(token);
        useDemoStore().changeUser_uid(userInfo.user_uid);
        // this.timer = setInterval(() => {
        //     this.getLastMessage();
        // }, 10000);
        if (this.website_id) {
          let website_id = this.website_id;
          if (website_id == "NaN") return;
          $axios
            .websitegetMsgCount({
              website_id: this.website_id,
            })
            .then((res) => {
              if (!res) return;
              if (!res.data) return;
              this.unreadCount = res.data.unreadcount;
              if (this.unreadCount) {
                window.parent.postMessage(
                  {
                    unreadCount: this.unreadCount,
                  },
                  "*"
                );
              }
            });
        }
        $axios
          .getUserOwner({
            token,
            user_uid: userInfo.user_uid,
          })
          .then((res) => {
            let user_type = res.data.user_info.user_type;
            let type = getWebType(res.data.user_info.type);
            let user_name = res.data.user_info.nickname;
            useDemoStore().changeType(type);
            useDemoStore().changeName(user_name);
            if (this.IsbindTourist) {
              let Visitortoken = getStore({
                name: "Visitortoken",
              });
              if (Visitortoken) {
                $axios
                  .bindTourist({
                    tourist_token: Visitortoken,
                    website_id: this.website_id,
                  })
                  .finally(() => {
                    this.init();
                  });
              } else {
                this.init();
              }
            } else {
              this.init();
            }
            if (user_type == 0) {
              useDemoStore().changeType(4);
              this.showTypeList = [
                {
                  value: "MyRFQ",
                  text: i18n.global.t("rfq.myRFQ"),
                },
                {
                  value: "ContactsRFQ",
                  text: i18n.global.t("rfq.ContactRFQ"),
                },
                {
                  value: "MyQTN",
                  text: i18n.global.t("rfq.myQTN"),
                },
                {
                  value: "PurchaseQTN",
                  text: i18n.global.t("rfq.CustomersQTN"),
                },
                {
                  value: "ContactQTN",
                  text: i18n.global.t("rfq.SubmitQTNToTheCustomer"),
                },
                {
                  value: "SaleOrder",
                  text: i18n.global.t("AfterSale.SaleOrder"),
                },
                {
                  value: "PurchaseOrder",
                  text: i18n.global.t("AfterSale.PurchaseOrder"),
                },
              ];
              this.owner_info_user_uid = res.data.user_info.owner_id;
              if (this.owner_info_user_uid) {
                this.chatIds.push(
                  ...[String(this.owner_info_user_uid), "1000000301"]
                );
              } else {
                let to_id = ["1000000301"];
                if (this.owner_id_str) {
                  to_id.push(...this.owner_id_str.split("|"));
                }
                this.chatIds.push(...to_id);
              }
            } else {
              if (type == 1 || type == 2 || type == 6) {
                this.showTypeList = [
                  {
                    value: "PublicRFQ",
                    text: i18n.global.t("rfq.PublicRFQ"),
                  },
                  {
                    value: "PersonalRFQ",
                    text: i18n.global.t("rfq.PersonalRFQ"),
                  },
                  {
                    value: "PurchaseQTN",
                    text: i18n.global.t("rfq.PurchaseQTN"),
                  },
                  {
                    value: "ContactQTN",
                    text: i18n.global.t("rfq.ContactsQTN"),
                  },
                  {
                    value: "SaleOrder",
                    text: i18n.global.t("AfterSale.SaleOrder"),
                  },
                  {
                    value: "PurchaseOrder",
                    text: i18n.global.t("AfterSale.PurchaseOrder"),
                  },
                ];
              } else {
                this.showTypeList = [
                  {
                    value: "PublicRFQ",
                    text: i18n.global.t("rfq.PublicRFQ"),
                  },
                  {
                    value: "PersonalRFQ",
                    text: i18n.global.t("rfq.PersonalRFQ"),
                  },
                  {
                    value: "PurchaseQTN",
                    text: i18n.global.t("rfq.PurchaseQTN"),
                  },
                  {
                    value: "PurchaseOrder",
                    text: i18n.global.t("AfterSale.PurchaseOrder"),
                  },
                ];
              }
              let to_id = ["1000000301"];
              if (this.owner_id_str) {
                to_id.push(...this.owner_id_str.split("|"));
              }
              this.chatIds.push(...to_id);
            }
          })
          .catch((res) => {
            if (res.Status == 401) {
              window.parent.postMessage(
                {
                  tokenErr: true,
                },
                "*"
              );
              $axios
                .slackreg({
                  website_id: this.website_id,
                })
                .then((res) => {
                  let data = res.data;
                  HomeStore().setuserInfo(res.data.data.userinfo);
                  HomeStore().setToken(data.token);
                  useDemoStore().changeToken(data.token);
                  setStore({
                    name: "Visitortoken",
                    content: data.token,
                  });
                  setStore({
                    name: "VisitoruserInfo",
                    content: data.data.userinfo,
                  });
                  this.Isvisitor = true;
                  this.setBasicInfo();
                });
            }
          });
      } else {
        let Visitortoken = getStore({
          name: "Visitortoken",
        });
        if (!Visitortoken) {
          $axios
            .slackreg({
              website_id: this.website_id,
            })
            .then((res) => {
              let data = res.data;
              HomeStore().setuserInfo(res.data.data.userinfo);
              HomeStore().setToken(data.token);
              useDemoStore().changeToken(data.token);
              setStore({
                name: "Visitortoken",
                content: data.token,
              });
              setStore({
                name: "VisitoruserInfo",
                content: data.data.userinfo,
              });
              this.Isvisitor = true;
              this.setBasicInfo();
            });
        } else {
          if (window.localStorage.getItem("Visitortoken")) {
            let token = JSON.parse(window.localStorage.getItem("Visitortoken"));
            let userInfo = JSON.parse(
              window.localStorage.getItem("VisitoruserInfo")
            );
            HomeStore().setuserInfo(userInfo);
            HomeStore().setToken(token);
            useDemoStore().changeToken(token);
            this.Isvisitor = true;
            this.setBasicInfo();
          } else {
            window.localStorage.setItem("IsLoad", "");
            this.setBasicInfo();
          }
        }
      }
    },
    //关闭会话列表
    closeClick() {
      this.showSessionListVisible = false;
    },
    //选择对象类型
    changeTypeClick(val) {
      this.selectInfo.type = "";
      this.selectInfo.type = val.value;
      this.selectInfo.Visible = true;
      HomeStore().selectData = "";
      window.parent.postMessage(
        {
          IsShowList: true,
        },
        "*"
      );
    },
    //取消发送对象
    selectCancel() {
      this.selectInfo.type = "";
      this.selectInfo.Visible = false;
      HomeStore().selectData = "";
      window.parent.postMessage(
        {
          IsShowList: false,
        },
        "*"
      );
    },
    //发送对象
    selectConfirm() {
      if (HomeStore().selectData == "") {
        if (useDemoStore().lang == "en-us") {
          ElMessage({
            type: "error",
            message: "Please Select Data.",
          });
        } else {
          ElMessage({
            type: "error",
            message: "请选择数据.",
          });
        }
        return;
      }
      let selectInfo = this.selectInfo;
      let userInfo = JSON.parse(window.localStorage.getItem("erp"));
      if (
        selectInfo.type == "PersonalRFQ" ||
        selectInfo.type == "PublicRFQ" ||
        selectInfo.type == "MyRFQ" ||
        selectInfo.type == "ContactsRFQ"
      ) {
        Rfq.$getInquiryInfo({
          token: HomeStore().token,
          inquiry_id: HomeStore().selectData.inquiry_id,
          isPublic: HomeStore().selectData.isPublic,
        }).then((inquiry) => {
          let inquiryInfo = inquiry.data.inquiryInfo;
          Rfq.$Product({
            token: HomeStore().token,
            id: HomeStore().selectData.inquiry_id,
            isPublic: HomeStore().selectData.isPublic,
          }).then((res) => {
            let obj_val = {};
            let PurchaseQTNcount = 0;
            let ContactQTNcount = 0;
            let modelList = res.data.data;
            Rfq.$orderget_order_purchase({
              token: HomeStore().token,
              inquiry_id: HomeStore().selectData.inquiry_id,
              isPublic: HomeStore().selectData.isPublic,
            }).then((res) => {
              PurchaseQTNcount = res.data.item.length;
              let queryData = {};
              if (selectInfo.type == "MyRFQ") {
                queryData = {
                  token: HomeStore().token,
                  inquiry_id: HomeStore().selectData.inquiry_id,
                  isPublic: HomeStore().selectData.isPublic,
                  customer_inquiry_type: 1,
                };
              } else {
                queryData = {
                  token: HomeStore().token,
                  inquiry_id: HomeStore().selectData.inquiry_id,
                  isPublic: HomeStore().selectData.isPublic,
                  isContact: 1,
                };
              }
              Rfq.$orderget_order_purchase(queryData).then((res) => {
                res.data.item.map((item, index) => {
                  item.model = item.product.model;
                  item.brand_name = item.brand.brand_name;
                  item.children.map((children) => {
                    children.model = item.product.model;
                    children.Qty = item.Qty;
                    children.brand_name = item.brand.brand_name;
                    res.data.item.push(children);
                  });
                });
                ContactQTNcount = res.data.item.length;
                let modelData = [];
                modelList.map((item) => {
                  modelData.push({
                    model: item.product.model,
                    Qty: item.Qty,
                  });
                });
                if (ContactQTNcount > 0) {
                  ContactQTNcount =
                    ContactQTNcount >= 10
                      ? ContactQTNcount
                      : "0" + ContactQTNcount;
                }
                if (PurchaseQTNcount > 0) {
                  PurchaseQTNcount =
                    PurchaseQTNcount >= 10
                      ? PurchaseQTNcount
                      : "0" + PurchaseQTNcount;
                }
                obj_val = {
                  modelData,
                  PurchaseQTNcount,
                  ContactQTNcount,
                  inquiryInfo: inquiryInfo,
                  slackType: selectInfo.type,
                  isPublic: HomeStore().selectData.isPublic,
                  user_type: userInfo.type,
                };
                if (HomeStore().setting.dialogueInfo.type == 1) {
                  let OtherList = this.MessageList.filter(
                    (item) => item.creator_id != HomeStore().userInfo.user_uid
                  );
                  let to_uid = HomeStore().setting.dialogueInfo.id;
                  if (!to_uid) {
                    if (OtherList.length > 0) {
                      to_uid = OtherList[OtherList.length - 1].creator_id;
                    } else {
                      to_uid = this.owner_id_str.split("|")[0];
                    }
                  }
                  this.owner_id_str.split("|");
                  var data = {
                    type: "PrivateChat",
                    token: HomeStore().token, // 用户Token
                    to_uid,
                    upload: "obj",
                    obj_type: "RFQ",
                    obj_val: JSON.stringify(obj_val),
                    message: ``, // 消息内容
                    obj_record: HomeStore().selectData.inquiry_id,
                    website_id: this.website_id,
                    channel: this.website_name || "Shop",
                    nowId: String(new Date().getTime()),
                    // read: 1
                  };
                  this.selectInfo.type = "";
                  // HomeStore().socket.send(JSON.stringify(data));
                  $axios.sendMsg(data).then(res => {
                    this.selectInfo.Visible = false
                    window.parent.postMessage(
                      {
                        IsShowList: false,
                      },
                      "*"
                    );
                  }).catch(() => {
                    ElMessage({
                      type: "info",
                      message: i18n.global.t("slack.connectedTip"),
                    });
                  })
                }
              });
            });
          });
        });
      }
      if (selectInfo.type == "PurchaseQTN" || selectInfo.type == "MyQTN") {
        Rfq.$getInquiryInfo({
          token: HomeStore().token,
          inquiry_id: HomeStore().selectData.inquiry_id,
          isPublic: HomeStore().selectData.isPublic,
        }).then((inquiry) => {
          let inquiryInfo = inquiry.data.inquiryInfo;
          Rfq.$Product({
            token: HomeStore().token,
            id: HomeStore().selectData.inquiry_id,
            isPublic: HomeStore().selectData.isPublic,
          }).then((res) => {
            let modelList = res.data.data;
            let modelData = [];
            modelList.map((item) => {
              modelData.push({
                model: item.product.model,
                Qty: item.Qty,
              });
            });
            Rfq.$orderget_order_purchase({
              token: HomeStore().token,
              inquiry_id: HomeStore().selectData.inquiry_id,
              isPublic:
                userInfo.type == 4 ? 4 : HomeStore().selectData.isPublic,
            }).then((res) => {
              res.data.qtn_createid = HomeStore().userInfo.user_uid;
              res.data.slackType = selectInfo.type;
              res.data.modelData = modelData;
              res.data.user_type = userInfo.type;
              let OtherList = this.MessageList.filter(
                (item) => item.creator_id != HomeStore().userInfo.user_uid
              );
              let to_uid = HomeStore().setting.dialogueInfo.id;
              if (!to_uid) {
                if (OtherList.length > 0) {
                  to_uid = OtherList[OtherList.length - 1].creator_id;
                } else {
                  to_uid = this.owner_id_str.split("|")[0];
                }
              }
              if (HomeStore().setting.dialogueInfo.type == 1) {
                var data = {
                  type: "PrivateChat",
                  token: HomeStore().token, // 用户Token
                  to_uid,
                  upload: "obj",
                  obj_type: "QTN",
                  obj_val: JSON.stringify(res.data),
                  message: ``,
                  obj_record: HomeStore().selectData.inquiry_id,
                  website_id: this.website_id,
                  channel: this.website_name || "Shop",
                  nowId: String(new Date().getTime()),
                  // read: 1
                };
                this.selectInfo.type = "";
                // HomeStore().socket.send(JSON.stringify(data));
                $axios.sendMsg(data).then(res => {
                  this.selectInfo.Visible = false
                  window.parent.postMessage(
                    {
                      IsShowList: false,
                    },
                    "*"
                  );
                }).catch(() => {
                  ElMessage({
                    type: "info",
                    message: i18n.global.t("slack.connectedTip"),
                  });
                })
              }
            });
          });
        });
      }
      if (selectInfo.type == "ContactQTN") {
        Rfq.$getInquiryInfo({
          token: HomeStore().token,
          inquiry_id: HomeStore().selectData.inquiry_id,
          isPublic: HomeStore().selectData.isPublic,
        }).then((inquiry) => {
          let inquiryInfo = inquiry.data.inquiryInfo;
          Rfq.$Product({
            token: HomeStore().token,
            id: HomeStore().selectData.inquiry_id,
            isPublic: HomeStore().selectData.isPublic,
          }).then((res) => {
            let modelList = res.data.data;
            let modelData = [];
            modelList.map((item) => {
              modelData.push({
                model: item.product.model,
                Qty: item.Qty,
              });
            });
            Rfq.$orderget_order_purchase({
              token: HomeStore().token,
              inquiry_id: HomeStore().selectData.inquiry_id,
              isPublic: HomeStore().selectData.isPublic,
              isContact: 1,
            }).then((res) => {
              res.data.qtn_createid = HomeStore().userInfo.user_uid;
              res.data.slackType = selectInfo.type;
              res.data.modelData = modelData;
              res.data.user_type = userInfo.type;
              let OtherList = this.MessageList.filter(
                (item) => item.creator_id != HomeStore().userInfo.user_uid
              );
              let to_uid = HomeStore().setting.dialogueInfo.id;
              if (!to_uid) {
                if (OtherList.length > 0) {
                  to_uid = OtherList[OtherList.length - 1].creator_id;
                } else {
                  to_uid = this.owner_id_str.split("|")[0];
                }
              }
              if (HomeStore().setting.dialogueInfo.type == 1) {
                var data = {
                  type: "PrivateChat",
                  token: HomeStore().token, // 用户Token
                  to_uid,
                  upload: "obj",
                  obj_type: "QTN",
                  obj_val: JSON.stringify(res.data),
                  message: ``,
                  obj_record: HomeStore().selectData.inquiry_id,
                  website_id: this.website_id,
                  channel: this.website_name || "Shop",
                  nowId: String(new Date().getTime()),
                  // read: 1
                };
                console.log(data);
                this.selectInfo.type = "";
                // HomeStore().socket.send(JSON.stringify(data));
                $axios.sendMsg(data).then(res => {
                  this.selectInfo.Visible = false
                  window.parent.postMessage(
                    {
                      IsShowList: false,
                    },
                    "*"
                  );
                }).catch(() => {
                  ElMessage({
                    type: "info",
                    message: i18n.global.t("slack.connectedTip"),
                  });
                })
              }
            });
          });
        });
      }
      if (selectInfo.type == "SaleOrder") {
        Order.orderDetail({
          token: HomeStore().token,
          order_id: HomeStore().selectData.order_id,
          page: 1,
          pageSize: 10,
          is_cost: 1,
          is_shipping: 1,
          msg: 1,
          // state: 0
        }).then((res) => {
          res.data.slackType = selectInfo.type;
          // pur_num
          // purtask_num
          let PurchaseOrderteskNum = 0;
          let PurchaseOrderNum = 0;
          if (res.data.purtask_num) {
            PurchaseOrderteskNum =
              res.data.purtask_num >= 10
                ? res.data.purtask_num
                : "0" + res.data.purtask_num;
          }
          if (res.data.pur_num) {
            PurchaseOrderNum =
              res.data.purtask_num >= 10
                ? res.data.pur_num
                : "0" + res.data.pur_num;
          }
          let obj_val = res.data;
          obj_val.user_type = userInfo.type;
          obj_val.PurchaseOrderteskNum = PurchaseOrderteskNum;
          obj_val.PurchaseOrderNum = PurchaseOrderNum;
          let OtherList = this.MessageList.filter(
            (item) => item.creator_id != HomeStore().userInfo.user_uid
          );
          let to_uid = HomeStore().setting.dialogueInfo.id;
          if (!to_uid) {
            if (OtherList.length > 0) {
              to_uid = OtherList[OtherList.length - 1].creator_id;
            } else {
              to_uid = this.owner_id_str.split("|")[0];
            }
          }
          var data = {
            type: "PrivateChat",
            token: HomeStore().token, // 用户Token
            to_uid,
            upload: "obj",
            obj_type: "SaleOrder",
            obj_val: JSON.stringify(obj_val),
            message: ``,
            obj_record: HomeStore().selectData.order_id,
            website_id: this.website_id,
            channel: this.website_name || "Shop",
            nowId: String(new Date().getTime()),
            // read: 1
          };
          this.selectInfo.type = "";
          // HomeStore().socket.send(JSON.stringify(data));
          $axios.sendMsg(data).then(res => {
            this.selectInfo.Visible = false
            window.parent.postMessage(
              {
                IsShowList: false,
              },
              "*"
            );
          }).catch(() => {
            ElMessage({
              type: "info",
              message: i18n.global.t("slack.connectedTip"),
            });
          })
        });
      }
      if (selectInfo.type == "PurchaseOrder") {
        if (userInfo.type == 4) {
          Order.cpoItem({
            token: HomeStore().token,
            page: 1,
            pageSize: 10,
            customer_order_id: HomeStore().selectData.customer_order_id,
            msg: 1,
          }).then((res) => {
            let obj_val = res.data;
            res.data.items.data.map((item) => {
              item.Model = item.model;
              item.dty = item.quantity;
            });
            obj_val.data = res.data.items.data;
            let PurchaseOrderteskNum = 0;
            // if (res.data.purtask_num) {
            //   PurchaseOrderteskNum =
            //     res.data.purtask_num >= 10
            //       ? res.data.purtask_num
            //       : "0" + res.data.purtask_num;
            // }
            obj_val.user_type = userInfo.type;
            obj_val.create_time = HomeStore().selectData.create_time;
            obj_val.purchaseorder_id = HomeStore().selectData.customer_order_id;
            obj_val.Purchaseordername = HomeStore().selectData.order_number;

            obj_val.create_name = HomeStore().selectData.create_name;
            // obj_val.create_user = HomeStore().selectData.create_user;
            obj_val.PurchaseOrderteskNum = PurchaseOrderteskNum;
            // obj_val.Contacts =
            //   HomeStore().selectData.firstname + HomeStore().selectData.lastname;
            obj_val.Contacts = userInfo.UserGroupName;
            obj_val.supplier_id = HomeStore().selectData.supplier_id;
            obj_val.supplier_company_id =
              HomeStore().selectData.supplier_company_id;
            // obj_val.PI_name = res.data.data[0].PI_name;
            obj_val.PI_name = "";
            let OtherList = this.MessageList.filter(
              (item) => item.creator_id != HomeStore().userInfo.user_uid
            );
            let to_uid = HomeStore().setting.dialogueInfo.id;
            if (!to_uid) {
              if (OtherList.length > 0) {
                to_uid = OtherList[OtherList.length - 1].creator_id;
              } else {
                to_uid = this.owner_id_str.split("|")[0];
              }
            }
            var data = {
              type: "PrivateChat",
              token: HomeStore().token, // 用户Token
              to_uid,
              upload: "obj",
              obj_type: "PurchaseOrder",
              obj_val: JSON.stringify(obj_val),
              message: ``,
              obj_record: HomeStore().selectData.purchaseorder_id,
              website_id: this.website_id,
              channel: this.website_name || "Shop",
              nowId: String(new Date().getTime()),
              // read: 1
            };
            this.selectInfo.type = "";
            // HomeStore().socket.send(JSON.stringify(data));
            $axios.sendMsg(data).then(res => {
              this.selectInfo.Visible = false
              window.parent.postMessage(
                {
                  IsShowList: false,
                },
                "*"
              );
            }).catch(() => {
              ElMessage({
                type: "info",
                message: i18n.global.t("slack.connectedTip"),
              });
            })
          });
        } else {
          Order.purchaseOrderDetailed({
            token: HomeStore().token,
            page: 1,
            pageSize: 10,
            Purchaseorder_id: HomeStore().selectData.purchaseorder_id,
            msg: 1,
          }).then((res) => {
            let obj_val = res.data;
            obj_val.data = res.data.list.data;
            let PurchaseOrderteskNum = 0;
            // if (res.data.purtask_num) {
            //   PurchaseOrderteskNum =
            //     res.data.purtask_num >= 10
            //       ? res.data.purtask_num
            //       : "0" + res.data.purtask_num;
            // }
            obj_val.create_time = HomeStore().selectData.create_time;
            obj_val.purchaseorder_id = HomeStore().selectData.purchaseorder_id;
            obj_val.Purchaseordername =
              HomeStore().selectData.Purchaseordername;
            obj_val.sale = HomeStore().selectData.sale;
            obj_val.create_name = HomeStore().selectData.create_name;
            obj_val.create_user = HomeStore().selectData.create_user;
            obj_val.PurchaseOrderteskNum = PurchaseOrderteskNum;
            obj_val.user_type = userInfo.type;
            // obj_val.Contacts =
            //   HomeStore().selectData.firstname + HomeStore().selectData.lastname;

            if (useDemoStore().lang == "zh-cn") {
              obj_val.Contacts =
                Kernaldec(HomeStore().selectData.lastname) +
                Kernaldec(HomeStore().selectData.firstname);
            } else {
              obj_val.Contacts =
                Kernaldec(HomeStore().selectData.firstname) +
                Kernaldec(HomeStore().selectData.lastname);
            }
            obj_val.supplier_id = HomeStore().selectData.supplier_id;
            obj_val.supplier_company_id =
              HomeStore().selectData.supplier_company_id;
            obj_val.PI_name = res.data.list.data[0].PI_name;

            Order.purchaseOrderTakeList({
              token: HomeStore().token,
              PI_name: res.data.data[0].PI_name,
              is_team: 1,
              purchaser_id: HomeStore().userInfo.user_uid,
              page: 1,
              pageSize: 10,
            }).then((res) => {
              if (res.data.total) {
                PurchaseOrderteskNum = res.data.total || 0;
              }
              if (PurchaseOrderteskNum) {
                PurchaseOrderteskNum =
                  PurchaseOrderteskNum >= 10
                    ? PurchaseOrderteskNum
                    : "0" + PurchaseOrderteskNum;
              }
              obj_val.PurchaseOrderteskNum = obj_val.PI_name
                ? PurchaseOrderteskNum
                : 0;
              let OtherList = this.MessageList.filter(
                (item) => item.creator_id != HomeStore().userInfo.user_uid
              );
              let to_uid = HomeStore().setting.dialogueInfo.id;
              if (!to_uid) {
                if (OtherList.length > 0) {
                  to_uid = OtherList[OtherList.length - 1].creator_id;
                } else {
                  to_uid = this.owner_id_str.split("|")[0];
                }
              }
              var data = {
                type: "PrivateChat",
                token: HomeStore().token, // 用户Token
                to_uid,
                upload: "obj",
                obj_type: "PurchaseOrder",
                obj_val: JSON.stringify(obj_val),
                message: ``,
                obj_record: HomeStore().selectData.purchaseorder_id,
                website_id: this.website_id,
                channel: this.website_name || "Shop",
                nowId: String(new Date().getTime()),
                // read: 1
              };
              this.selectInfo.type = "";
              // HomeStore().socket.send(JSON.stringify(data));
              $axios.sendMsg(data).then(res => {
                this.selectInfo.Visible = false
                window.parent.postMessage(
                  {
                    IsShowList: false,
                  },
                  "*"
                );
              }).catch(() => {
                ElMessage({
                  type: "info",
                  message: i18n.global.t("slack.connectedTip"),
                });
              })
            });
          });
        }
      }
    },
    //显示会话列表的单击事件
    showSessionListVisibleClick() {
      this.showSessionListVisible = !this.showSessionListVisible;
      this.sessionObjectKeyWord = "";
      this.searchSessionList("");
    },
    //搜索会话对象
    searchSessionList: debounce(function (val) {
      this.showchannelList = HomeStore().channelList.filter((item) => {
        item.group_name = item.group_name ? item.group_name : "";
        return (
          item.group_name
            .toLocaleLowerCase()
            .indexOf(val.toLocaleLowerCase()) != -1
        );
      });
      this.friendList = HomeStore().friends.filter((item) => {
        item.receiver_name = item.receiver_name ? item.receiver_name : "";
        return (
          item.receiver_name
            .toLocaleLowerCase()
            .indexOf(val.toLocaleLowerCase()) != -1
        );
      });
      if (val) {
        $axios
          .rfqGroupList({
            token: useDemoStore().token,
            page: 1,
            limit: 50,
            keyword: val,
          })
          .then((res) => {
            res.data.map((item) => {
              if (!(item.group_id in HomeStore().chatMessageList)) {
                HomeStore().chatMessageList[item.group_id] = [];
                HomeStore().isNeedQuery[item.group_id] = true;
                item.creator_id = item.user_id;
              }
            });
            this.showrfqGroupList = extend(res.data, true).sort(
              this.sortByUnRead
            );
          });
      }
    }, 500),
    //查看频道详情
    viewChanneldetails() { },
    //添加好友事件
    addFriendClick() { },
    //创建频道事件
    createChannelClick() { },
    //有新的聊天记录
    newMessage() {
      let view = this.$refs.view_body;
      setTimeout(() => {
        view.scrollTop = view.scrollHeight;
      }, 100);
      HomeStore().IsSendMessage = false;
    },
    //获取未读消息的总数
    GetunreadCount: debounce(function () {
      this.unreadCount = 0;
      this.MessageList.map((item) => {
        if (item.read == 0) {
          this.unreadCount += 1;
        }
      });
      // this.SessionList.map((item) => {
      //     this.unreadCount += item.unread;
      // });
      window.parent.postMessage(
        {
          unreadCount: this.unreadCount,
          user_uid: HomeStore().userInfo.user_uid,
        },
        "*"
      );
    }, 100),
    //全部已读
    AllRead() {
      $axios
        .allread({
          token: useDemoStore().token,
        })
        .then(() => {
          ElMessage({
            type: "success",
            message: i18n.global.t("com.handleSuccess"),
          });
          HomeStore().friends.map((item) => {
            item.unread = 0;
          });
          HomeStore().channelList.map((item) => {
            item.unread = 0;
          });
          HomeStore().rfqGroupList.map((item) => {
            item.unread = 0;
          });
        });
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    //判断是否显示头像
    showUserprofilepicture(item, index) {
      if (HomeStore().setting.dialogueInfo.type == 1) {
        if (index == 0) {
          return true;
        } else {
          if (item.creator_id == this.MessageList[index - 1].creator_id) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        return true;
      }
    },
    //判断是否显示时间
    showtimestamp(item, index) {
      if (index == 0) {
        if (item.creator_id == this.MessageList[index + 1].creator_id) {
          let nowTime = new Date(parseTime(item.create_time)).getTime();
          let upTime = new Date(
            parseTime(this.MessageList[index + 1].create_time)
          ).getTime();
          if ((upTime - nowTime) / 1000 < 60) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else if (index + 1 == this.MessageList.length) {
        return true;
      } else {
        let nowTime = new Date(parseTime(item.create_time)).getTime();
        let upTime = new Date(
          parseTime(this.MessageList[index + 1].create_time)
        ).getTime();
        if ((upTime - nowTime) / 1000 < 60) {
          return false;
        } else {
          return true;
        }
      }
    },
    //回到好友列表
    backFriends() {
      this.showType = 1;
      if (HomeStore().setting.dialogueInfo.type == 1) {
        this.saveBackId = HomeStore().setting.dialogueInfo.id;
        HomeStore().setting.dialogueInfo.id = -1;
      } else {
        this.saveBackId = HomeStore().setting.dialogueInfo.group_id;
        HomeStore().setting.dialogueInfo.group_id = -1;
      }
      this.getLastMessage();
    },
    //回到聊天页面
    backChat() {
      if (this.saveBackId == "") {
        return;
      }
      if (HomeStore().setting.dialogueInfo.type == 1) {
        HomeStore().setting.dialogueInfo.id = this.saveBackId;
        let index = HomeStore().friends.findIndex((f) => {
          return f.user_uid == this.saveBackId;
        });
        if (index == -1) {
          return;
        }
        HomeStore().friends[index].unread = 0;
        $axios.msgread({
          token: HomeStore().token,
          friend_id: this.saveBackId,
        });
      } else {
        HomeStore().setting.dialogueInfo.group_id = this.saveBackId;
        let index = HomeStore().channelList.findIndex((c) => {
          return c.group_id == this.saveBackId;
        });
        if (index == -1) {
          return;
        }
        HomeStore().channelList[index].unread = 0;
        $axios.groupread({
          token: HomeStore().token,
          group_id: this.saveBackId,
          readtype: "read",
        });
      }
      this.showType = 2;
      this.showSessionListVisible = false;
      this.getSessionChat();
      nextTick(() => {
        let view = this.$refs.view_body;
        setTimeout(() => {
          view.scrollTop = view.scrollHeight;
        }, 500);
        HomeStore().IsSendMessage = false;
        this.$refs["MsgInp"].focus();
      });
    },
    //滚动聊天记录
    scrollMessageList: debounce(function (val) {
      if (this.showType == 1) {
        return;
      }
      let scrollTop = val.target.scrollTop;
      let Id = this.website_id;
      if (HomeStore().Messagetip[Id]) {
        let index = this.MessageList.findIndex((item) => {
          return !item.isRead;
        });
        if (index < 0) {
          HomeStore().Messagetip[Id] = false;
          return;
        }
        let id = this.MessageList[index].id;
        if (!document.getElementById(id)) {
          return;
        }
        let scrollTop1 = document.getElementById(id).offsetTop;
        if (scrollTop1 > scrollTop) {
          setTimeout(() => {
            HomeStore().Messagetip[Id] = false;
          }, 500);
          $axios.websiteMsgread({
            website_id: this.website_id,
          });
          setTimeout(() => {
            this.MessageList.map((item) => {
              item.isRead = true;
              item.read = 1;
            });
            this.GetunreadCount();
          }, 1000);
        }
      }
      if (scrollTop <= 0) {
        if (!HomeStore().chatQuery[this.website_id].load) {
          return;
        }
        HomeStore().setting.loading = true;
        HomeStore().chatQuery[this.website_id].page += 1;
        $axios
          .websiteChatlog({
            website_id: this.website_id,
            page: HomeStore().chatQuery[this.website_id].page,
            total: HomeStore().chatQuery[this.website_id].total,
            min_msg_id: this.MessageList[0].id,
          })
          .then((res) => {
            let List = [];
            res.data.map((item) => {
              item.user_avatar_file_name = item.creator_face
              List.push(item);
              if (item.son) {
                item.replyMessageList = item.son;
                item.replyMessageList.map((r) => {
                  r.user_avatar_file_name = r.creator_face
                  r.del_user_id = r.del_user_id ? r.del_user_id : "";
                  r.isRead = true;
                  r.replyMessageList = [];
                  r.MainId = item.id;
                  r.Maincontent = item.content;
                  r.Maincreate_time = item.create_time;
                  r.Maincreator_name = item.creator_name;
                  if ("obj_type" in item) {
                    r.obj_type = item.obj_type;
                    r.obj_val = item.obj_val;
                  }
                  if ("file_path" in item) {
                    r.Mainfile_path = item.file_path;
                    r.Mainfile_name = item.file_name;
                    r.Mainmimetype = item.mimetype;
                  }
                  List.push(r);
                });
              } else {
                item.replyMessageList = [];
              }
              item.del_user_id = item.del_user_id ? item.del_user_id : "";
              item.isRead = true;
            });
            if (res.data.length < 50) {
              HomeStore().chatQuery[this.website_id].load = false;
            }
            List = List.filter((item) => {
              return (
                item.del_user_id.indexOf(String(this.userInfo.user_uid)) == -1
              );
            });
            let index = -1;
            List.map((item, index1) => {
              if (item.read == 0 && item.creator_id != this.userInfo.user_uid) {
                index = index1;
                item.isRead = false;
              }
            });
            if (index >= 0) {
              HomeStore().Messagetip[this.website_id] = true;
              // List[index].isRead = false;
            }
            this.MessageList.unshift(...List);
            let view = this.$refs.view_body;
            let scrollHeight = this.$refs.view_body.scrollHeight;
            setTimeout(() => {
              view.scrollTop = view.scrollHeight - scrollHeight;
            }, 100);
          })
          .finally(() => {
            HomeStore().setting.loading = false;
          });
      }
    }, 500),
    //获取会话对象的最后一条消息记录
    getLastMessage: debounce(function () {
      this.SessionList.map((item) => {
        let List = [];
        if ("user_uid" in item) {
          List = HomeStore().chatMessageList[item.user_uid].sort(this.compare);
        } else {
          List = HomeStore().chatMessageList[item.group_id].sort(this.compare);
        }
        if (List.length > 0) {
          let index = List.length - 1;
          item.messageTime = getupdate_time1(List[index].create_time);
          let obj = List[index];
          if (obj.file_name) {
            let name = obj.file_name.split(".");
            obj.suffixName = name[name.length - 1];
            if (!obj.mimetype) {
              obj.mimetype = obj.suffixName;
            }
          }
          item.content = extend(obj, true);
        }
      });
    }, 100),
    //获取用户消息记录
    getSessionChat: debounce(function () {
      this.MessageList.map((res) => {
        if (res.obj_type) {
          res.obj_type1 = res.obj_type;
          if (
            res.obj_type == "MergeForward" ||
            res.obj_type == "System" ||
            res.obj_type == "SystemAutoReply1" ||
            res.obj_type == "SystemAutoReply2"
          ) {
            res.obj_type = "";
          }
          res.obj_val = res.obj_val || null;
          if (res.obj_type == "SaleOrder") {
            res.obj_type1 = "Sale Order";
          } else if (res.obj_type == "PurchaseOrder") {
            res.obj_type1 = "Purchase Order";
          } else if (res.obj_type == "Ship") {
            res.obj_type1 = "Shipment";
          } else if (res.obj_type == "Ship") {
            res.obj_type1 = "Shipment";
          }
        }
      });
    }, 10),
    //改变消息状态
    setMessageState: debounce(function (val) {
      let view = this.$refs.view_body;
      let Id = val.group_id ? val.group_id : val.id;
      if (this.unreadCount > 0) {
        $axios.websiteMsgread({
          website_id: this.website_id,
        });
      }
      let index = this.MessageList.findIndex((item) => {
        return item.read === 0 && item.creator_id != this.userInfo.user_uid;
      });
      if (index >= 0) {
        this.MessageList[index].isRead = false;
        let id = this.MessageList[index].id;
        if (!document.getElementById(id)) {
          return;
        }
        let height = document.getElementById(id).offsetTop;
        if (view.scrollHeight - height <= view.clientHeight) {
          HomeStore().Messagetip[Id] = false;
          setTimeout(() => {
            this.MessageList.map((item) => {
              item.isRead = true;
              item.read = 1;
            });
          }, 1000);
        } else {
          HomeStore().Messagetip[Id] = true;
          this.MessageList.map((item) => {
            if (item.isRead) {
              if (
                document.getElementById(item.id).offsetTop < view.clientHeight
              ) {
                item.isRead = true;
                item.read = 1;
              }
            }
          });
        }
      }
      setTimeout(() => {
        this.GetunreadCount();
      }, 1000);
    }, 500),
    assignEvent: debounce(function () {
      $axios
        .assign({
          website_id: this.website_id,
          visitor_id: this.visitor_id,
          product_owner_id: this.engineer_id,
          vendor_id: this.vendor_id,
        })
        .then((res) => {
          let item = res.data;
          if (res.data.user_type == 0) {
            if (this.provide_management_type == 2) {
              this.showPlatformIntervention = true;
            }
          }
          HomeStore().setConfig("dialogueInfo", {
            type: 1,
            HeadPhotoUrl: item.profile_photo,
            id: item.user_uid,
            nickname: item.nickname,
            isOnline: item.isOnline,
          });
        });
    }, 500),
    //是否显示按钮
    getShowIcon: debounce(function () {
      let view = document.getElementsByClassName('MessageList')[0]
      if (view.scrollHeight > view.clientHeight) {
        this.ShowIcon = true
      } else {
        this.ShowIcon = false;
      }
    }, 500),
    //滚动到新消息
    backNewMsg() {
      let view = this.$refs.view_body;
      let Id = this.dialogueInfo.group_id
        ? this.dialogueInfo.group_id
        : this.dialogueInfo.id;
      let index = this.MessageList.findIndex((item) => {
        return !item.isRead;
      });
      if (index < 0) {
        HomeStore().Messagetip[Id] = false;
        return;
      }
      let id = this.MessageList[index].id;
      if (!document.getElementById(id)) {
        return;
      }
      setTimeout(() => {
        view.scrollTop = document.getElementById(id).offsetTop - 210;
        HomeStore().Messagetip[Id] = false;
        if (this.dialogueInfo.type == 1) {
          $axios
            .msgread({
              token: HomeStore().token,
              friend_id: this.dialogueInfo.id,
            })
            .then(() => {
              HomeStore().getunReadMsgCount();
            });
        } else {
          $axios
            .groupread({
              token: HomeStore().token,
              group_id: this.dialogueInfo.group_id,
              readtype: "read",
            })
            .then(() => {
              HomeStore().getunReadMsgCount();
            });
        }
      }, 500);
      setTimeout(() => {
        this.MessageList.map((item) => {
          item.isRead = true;
          item.read = 1;
        });
        this.GetunreadCount();
      }, 1000);
    },
    backtop() {
      if (
        HomeStore().Messagetip[this.dialogueInfo.id] ||
        HomeStore().Messagetip[this.dialogueInfo.group_id]
      ) {
        this.backNewMsg();
        return;
      }
      let view = this.$refs.view_body;
      setTimeout(() => {
        view.scrollTop = 20;
      }, 200);
    },
    backbottom() {
      let view = this.$refs.view_body;
      setTimeout(() => {
        view.scrollTop = view.scrollHeight;
      }, 100);
    },
    //私聊记录
    getChatMessageList(val) {
      HomeStore().setting.loading = true;
      HomeStore().chatScrollTop[val.user_uid] = -1;
      HomeStore().isNeedQuery[val.user_uid] = false;
      HomeStore().Messagetip[val.user_uid] = false;
      $axios
        .websiteChatlog({
          website_id: this.website_id,
          page: 1,
          total: 50,
        })
        .then((res) => {
          let List = [];
          res.data.map((item) => {
            item.user_avatar_file_name = item.creator_face
            List.push(item);
            if (item.son) {
              item.replyMessageList = item.son;
              item.replyMessageList.map((r) => {
                r.user_avatar_file_name = r.creator_face
                r.del_user_id = r.del_user_id ? r.del_user_id : "";
                r.isRead = true;
                r.replyMessageList = [];
                r.MainId = item.id;
                r.Maincontent = item.content;
                r.Maincreate_time = item.create_time;
                r.Maincreator_name = item.creator_name;
                if ("obj_type" in item) {
                  r.obj_type = item.obj_type;
                  r.obj_val = item.obj_val;
                }
                if ("file_path" in item) {
                  r.Mainfile_path = item.file_path;
                  r.Mainfile_name = item.file_name;
                  r.Mainmimetype = item.mimetype;
                }
                List.push(r);
              });
            } else {
              item.replyMessageList = [];
            }
            item.del_user_id = item.del_user_id ? item.del_user_id : "";
            item.isRead = true;
          });
          List = List.filter((item) => {
            return (
              item.del_user_id.indexOf(String(HomeStore().userInfo.user_uid)) ==
              -1
            );
          });
          let index = -1;
          List.map((item, index1) => {
            if (
              item.read == 0 &&
              item.creator_id != HomeStore().userInfo.user_uid
            ) {
              index = index1;
              item.isRead = false;
            }
          });
          if (index >= 0) {
            HomeStore().Messagetip[val.user_uid] = true;
          }
          this.MessageList = List.sort(this.compare);
          this.getShowIcon(this.dialogueInfo);
          $axios
            .assign({
              website_id: this.website_id,
              visitor_id: this.visitor_id,
              product_owner_id: this.engineer_id,
              vendor_id: this.vendor_id,
            })
            .then((ass) => {
              let item = ass.data;
              if (res.data.user_type == 0) {
                if (this.provide_management_type == 2) {
                  this.showPlatformIntervention = true;
                }
              }
              HomeStore().setConfig("dialogueInfo", {
                type: 1,
                HeadPhotoUrl: item.profile_photo,
                id: item.user_uid,
                nickname: item.nickname,
                isOnline: item.isOnline,
              });
              HomeStore().chatQuery[this.website_id] = {
                page: 1,
                total: 50,
                load: true,
              };
              if (res.data.length < 50) {
                HomeStore().chatQuery[this.website_id].load = false;
              }
            })
            .finally(() => {
              HomeStore().setting.loading = false;
            });
          nextTick(() => {
            let view = this.$refs.view_body;
            setTimeout(() => {
              view.scrollTop = view.scrollHeight;
            }, 500);
            HomeStore().IsSendMessage = false;
            this.$refs["MsgInp"].focus();
          });
        });
    },
    //群聊记录
    getgroupchat(item) { },
    compare(a, b) {
      // 使用 toUpperCase() 忽略字符大小写
      const bandA = new Date(a.create_time);
      const bandB = new Date(b.create_time);
      let comparison = 0;
      if (bandA > bandB) {
        comparison = 1;
      } else if (bandA < bandB) {
        comparison = -1;
      }
      return comparison;
    },
    //上传文件
    uploadFile(val) {
      let type = val.file.type;
      let name = val.file.name.split(".");
      let fileExt = [
        "gif",
        "jpg",
        "png",
        "jpeg",
        "webp",
        "txt",
        "xlsx",
        "xls",
        "pdf",
        "sql",
        "doc",
        "ppt",
        "pptx",
        "docx",
        "mp4",
      ];
      if (fileExt.indexOf(name[name.length - 1]) == -1) {
        ElMessage({
          type: "info",
          message: "Unsupported file type.",
        });
        return;
      }
      if (val.file.size / 1000 / 1024 > 50) {
        return ElMessage({
          type: "error",
          message: "File size out of range",
        });
      }

      const reader = new FileReader();
      reader.onload = () => {
        let file_path = reader.result;
        this.saveFile.file_name = val.file.name;
        this.saveFile.suffixName = name[name.length - 1];
        this.saveFile.type = type ? type : name[name.length - 1];
        this.saveFile.mimetype = type;
        this.saveFile.isUpload = true;
        this.saveFile.file_path = file_path;
        let obj = new FormData();
        obj.append("token", HomeStore().token);
        obj.append("file", val.file);
        axios({
          method: "post",
          url: HomeStore().baseURL + "/wkman/UploadToTencentCloud",
          "Content-type": "multipart/form-data",
          data: obj,
          cancelToken: new axios.CancelToken((c) => {
            this.saveFile.cancel = c;
          }),
        }).then((res) => {
          this.saveFile.file_path = res.data.data.file_path;
          this.saveFile.isUpload = false;
          let view = this.$refs.view_body;
          setTimeout(() => {
            view.scrollTop = view.scrollHeight;
          }, 100);
        });
      };
      reader.readAsDataURL(val.file);
    },
    //移除文件
    removeFile() {
      this.saveFile.cancel();
      this.saveFile.file_path = "";
    },
    //获取输入的文字
    inpuContent(val) {
      this.MessageText = val.target.innerText;
      this.inpuContentHeight = val.target.offsetHeight;
    },
    KeyEvent() {
      this.$refs.MsgInp.innerHTML += "<br>";
      if (this.MessageText.indexOf("<br>") == -1) {
        this.$refs.MsgInp.innerHTML += "<br>";
      }
      this.moveCursorToEnd(this.$refs.MsgInp);
      this.MessageText = this.$refs.MsgInp.innerHTML;
      this.inpuContentHeight = this.$refs.MsgInp.offsetHeight;
    },
    //重置焦点
    moveCursorToEnd(element) {
      if (typeof element.focus === "function") {
        element.focus(); // 设置焦点
      }
      if (typeof document.createRange === "function") {
        var range = document.createRange();
        range.selectNodeContents(element);
        range.collapse(false); // 光标移至最后
        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      } else if (typeof document.body.createTextRange === "function") {
        var textRange = document.body.createTextRange();
        textRange.moveToElementText(element);
        textRange.collapse(false);
        textRange.select();
      }
    },
    //发送消息
    sendMessage() {
      if (this.TipMessage()) {
        return;
      }
      if (HomeStore().setting.dialogueInfo.type == 1) {
        let OtherList = this.MessageList.filter(
          (item) => item.creator_id != HomeStore().userInfo.user_uid
        );
        let to_uid = HomeStore().setting.dialogueInfo.id;
        if (!to_uid) {
          if (OtherList.length > 0) {
            to_uid = OtherList[OtherList.length - 1].creator_id;
          } else {
            to_uid = this.owner_id_str.split("|")[0];
          }
        }
        if (this.MessageText.trim()) {
          var data = {
            type: "PrivateChat",
            token: HomeStore().token, // 用户Token
            to_uid,
            message: this.$refs.MsgInp.innerHTML, // 消息内容
            upload: "contents",
            website_id: this.website_id,
            channel: this.website_name || "Shop",
            nowId: String(new Date().getTime()),
          };
          console.log(data, "发送的数据");
          // HomeStore().socket.send(JSON.stringify(data));
          $axios.sendMsg(data).then(res => {
            this.MessageText = "";
            this.$refs.MsgInp.innerHTML = "";
            this.$refs.MsgInp.innerText = "";
          }).catch(() => {
            ElMessage({
              type: "info",
              message: i18n.global.t("slack.connectedTip"),
            });
          })
        }
        if (this.saveFile.file_path) {
          let OtherList = this.MessageList.filter(
            (item) => item.creator_id != HomeStore().userInfo.user_uid
          );
          let to_uid = HomeStore().setting.dialogueInfo.id;
          if (!to_uid) {
            if (OtherList.length > 0) {
              to_uid = OtherList[OtherList.length - 1].creator_id;
            } else {
              to_uid = this.owner_id_str.split("|")[0];
            }
          }
          var data = {
            type: "PrivateChat",
            token: HomeStore().token, // 用户Token
            to_uid,
            message: this.saveFile.file_path, // 消息内容
            file_name: this.saveFile.file_name,
            upload: "file",
            mimetype: this.saveFile.type,
            website_id: this.website_id,
            channel: this.website_name || "Shop",
            nowId: String(new Date().getTime()),
          };
          console.log(data, "发送的数据");
          // HomeStore().socket.send(JSON.stringify(data));
          $axios.sendMsg(data).then(res => {
            this.saveFile.file_path = "";
          }).catch(() => {
            ElMessage({
              type: "info",
              message: i18n.global.t("slack.connectedTip"),
            });
          })
        }
      } else {
        if (this.MessageText.trim()) {
          var data = {
            type: "GroupChat",
            token: HomeStore().token, // 用户Token
            group_id: HomeStore().setting.dialogueInfo.group_id, // 目标用户ID
            user_id: HomeStore().userInfo.user_uid,
            message: this.$refs.MsgInp.innerHTML, // 消息内容
            upload: "contents",
            website_id: this.website_id,
            channel: this.website_name || "Shop",
            nowId: String(new Date().getTime()),
          };
          console.log(data, "发送的数据");
          // HomeStore().socket.send(JSON.stringify(data));
          $axios.sendMsg(data).then(res => {
            this.MessageText = "";
            this.$refs.MsgInp.innerHTML = "";
            this.$refs.MsgInp.innerText = "";
          }).catch(() => {
            ElMessage({
              type: "info",
              message: i18n.global.t("slack.connectedTip"),
            });
          })
        }
        if (this.saveFile.file_path) {
          var data = {
            type: "GroupChat",
            token: HomeStore().token, // 用户Token
            group_id: HomeStore().setting.dialogueInfo.group_id, // 目标用户ID
            user_id: HomeStore().userInfo.user_uid,
            message: this.saveFile.file_path, // 消息内容
            file_name: this.saveFile.file_name,
            upload: "file",
            mimetype: this.saveFile.type,
            website_id: this.website_id,
            channel: this.website_name || "Shop",
            nowId: String(new Date().getTime()),
          };
          console.log(data, "发送的数据");
          // HomeStore().socket.send(JSON.stringify(data));
          $axios.sendMsg(data).then(res => {
            this.saveFile.file_path = "";
          }).catch(() => {
            ElMessage({
              type: "info",
              message: i18n.global.t("slack.connectedTip"),
            });
          })
        }
      }
    },
    //提示信息
    TipMessage() {
      if (this.dialogueInfo.type == 1) {
        if (HomeStore().isError[this.dialogueInfo.id]) {
          if (useDemoStore().lang == "en-us") {
            ElMessage({
              type: "error",
              message: "The other party has removed you.",
            });
          } else {
            ElMessage({
              type: "error",
              message: "对方将你删除了.",
            });
          }
          return true;
        } else {
          return false;
        }
      } else {
        if (HomeStore().isError[this.dialogueInfo.group_id]) {
          if (useDemoStore().lang == "en-us") {
            ElMessage({
              type: "error",
              message: "The channel has been disbanded.",
            });
          } else {
            ElMessage({
              type: "error",
              message: "频道已解散.",
            });
          }
          return true;
        } else {
          return false;
        }
      }
    },
    //获取未读私信消息
    getMyMsg() {
      return;
      const axiosInstance = axios1.create({
        transformResponse: [
          function (data) {
            // 对data进行JSON解析
            return getRealJsonData(data);
          },
        ],
      });
      axiosInstance({
        url: HomeStore().baseURL + "/wkman/getMyMsg",
        method: "post",
        data: {
          token: HomeStore().token,
        },
      })
        .then((res) => {
          if (res.data.Status == 1) {
            this.Timer = "";
            return;
          }
          if (!this.IsFirstOpen) {
            HomeStore().friends.map((item) => {
              item.unread = 0;
            });
            this.IsFirstOpen = true;
          }
          let List = res.data.data.filter((item) => {
            return item.id;
          });
          let receiver_ids = [];
          let MessageList = {};
          let AddFriends = [];
          List.map((item) => {
            if (receiver_ids.indexOf(item.creator_id) == -1) {
              receiver_ids.push(item.creator_id);
            }
            if (!(item.creator_id in HomeStore().isNeedQuery)) {
              AddFriends.push(item);
            }
          });
          AddFriends.map((item) => {
            let index = HomeStore().friends.findIndex((f) => {
              return f.user_uid == item.creator_id;
            });
            if (index == -1) {
              axiosInstance({
                url: HomeStore().baseURL + "/wkman/getTouristComeFrom",
                method: "post",
                data: {
                  token: HomeStore().token,
                  user_uid: item.creator_id,
                },
              }).then((visit) => {
                HomeStore().friends.push({
                  receiver_id: item.creator_id,
                  receiver_name: item.creator_name,
                  user_avatar_file_name: item.friend_avatar_file_name,
                  user_mail: "",
                  user_sex: "",
                  user_uid: item.creator_id,
                  unread: 0,
                  isOnline: 0,
                  website_id: visit.data.data.website_id,
                  website_title: visit.data.data.website_title,
                });
                HomeStore().chatMessageList[item.creator_id] = [];
                HomeStore().isNeedQuery[item.creator_id] = true;
              });
            }
          });
          receiver_ids.map((item) => {
            MessageList[item] = List.filter((res) => {
              return res.creator_id == item;
            });
          });
          for (let i in MessageList) {
            if (i in HomeStore().chatMessageList) {
              MessageList[i].map((item) => {
                let index = HomeStore().chatMessageList[i].findIndex((c) => {
                  return item.id == c.id;
                });
                if (index == -1) {
                  item.replyMessageList = [];
                  if (HomeStore().setting.dialogueInfo.id != i) {
                    let friendsIndex = HomeStore().friends.findIndex(
                      (friend) => {
                        return friend.user_uid == i;
                      }
                    );
                    HomeStore().friends[friendsIndex].unread += 1;
                    HomeStore().getunReadMsgCount();
                  } else {
                    $axios
                      .msgread({
                        token: HomeStore().token,
                        friend_id: i,
                      })
                      .then(() => {
                        HomeStore().getunReadMsgCount();
                      });

                    if (HomeStore().visibilityState) {
                      item.isRead = true;
                      item.read = 1;
                    } else {
                      item.read = 0;
                    }
                  }
                  if (!item.reply_id) {
                    HomeStore().chatMessageList[i].push(item);
                    HomeStore().IsSendMessage = true;
                  } else {
                    let MessageIndex = HomeStore().chatMessageList[i].findIndex(
                      (m) => {
                        return m.id == item.reply_id;
                      }
                    );
                    if (MessageIndex != -1) {
                      let huifuIndex = HomeStore().chatMessageList[i][
                        MessageIndex
                      ].replyMessageList.findIndex((reply) => {
                        return reply.id == item.id;
                      });
                      if (huifuIndex == -1) {
                        HomeStore().chatMessageList[i][
                          MessageIndex
                        ].replyMessageList.push(item);
                        let MsgObj = extend(item, true);
                        MsgObj.isRead = true;
                        MsgObj.replyMessageList = [];
                        MsgObj.MainId =
                          HomeStore().chatMessageList[i][MessageIndex].id;
                        MsgObj.Maincontent =
                          HomeStore().chatMessageList[i][MessageIndex].content;
                        MsgObj.Maincreate_time =
                          HomeStore().chatMessageList[i][
                            MessageIndex
                          ].create_time;
                        MsgObj.Maincreator_name =
                          HomeStore().chatMessageList[i][
                            MessageIndex
                          ].creator_name;
                        if (
                          "obj_type" in
                          HomeStore().chatMessageList[i][MessageIndex]
                        ) {
                          MsgObj.obj_type =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].obj_type;
                          MsgObj.obj_val =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].obj_val;
                        }
                        if ("file_path" in item) {
                          MsgObj.Mainfile_path =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].file_path;
                          MsgObj.Mainfile_name =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].file_name;
                          MsgObj.Mainmimetype =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].mimetype;
                        }
                        HomeStore().chatMessageList[i].push(MsgObj);
                        HomeStore().IsSendMessage = true;
                      }
                    }
                  }
                }
              });
            }
          }
        })
        .finally(() => {
          if (this.Timer) {
            setTimeout(() => {
              this.getMyMsg();
            }, 3000);
          }
        });
    },
    //获取未读群聊消息
    getMyGroupMsg() {
      return;
      const axiosInstance = axios1.create({
        transformResponse: [
          function (data) {
            // 对data进行JSON解析
            return getRealJsonData(data);
          },
        ],
      });
      axiosInstance({
        url: HomeStore().baseURL + "/wkman/getMyGroupMsg",
        method: "post",
        data: {
          token: HomeStore().token,
        },
      })
        .then((res) => {
          if (res.data.Status == 1) {
            this.Timer1 = "";
            return;
          }
          if (!this.IsFirstOpen1) {
            HomeStore().channelList.map((item) => {
              item.unread = 0;
            });
            this.IsFirstOpen1 = true;
          }
          let List = res.data.data.filter((item) => {
            return item.id;
          });
          let group_ids = [];
          let MessageList = {};
          let AddrfqGroupList = [];
          List.map((item) => {
            if (group_ids.indexOf(item.group_id) == -1) {
              group_ids.push(item.group_id);
            }
            let index = HomeStore().channelList.findIndex((Group) => {
              return item.group_id == Group.group_id;
            });
            if (index == -1 && item.inquiry_id) {
              AddrfqGroupList.push(item);
            }
          });
          AddrfqGroupList.map((item) => {
            let index = HomeStore().channelList.findIndex((f) => {
              return f.group_id == item.group_id;
            });
            if (index == -1) {
              HomeStore().channelList.push({
                group_name: item.group_name,
                description: "",
                group_id: item.group_id,
                unread: 0,
              });
              if (!(item.group_id in HomeStore().chatMessageList)) {
                HomeStore().chatMessageList[item.group_id] = [];
                HomeStore().isNeedQuery[item.group_id] = true;
              }
            }
          });
          group_ids.map((item) => {
            MessageList[item] = List.filter((res) => {
              return res.group_id == item;
            });
          });
          for (let i in MessageList) {
            if (i in HomeStore().chatMessageList) {
              MessageList[i].map((item) => {
                let index = HomeStore().chatMessageList[i].findIndex((c) => {
                  return item.id == c.id;
                });
                if (index == -1) {
                  item.replyMessageList = [];
                  if (HomeStore().setting.dialogueInfo.group_id != i) {
                    let channelIndex = HomeStore().channelList.findIndex(
                      (channel) => {
                        return channel.group_id == i;
                      }
                    );
                    if (channelIndex != -1) {
                      HomeStore().channelList[channelIndex].unread += 1;
                      HomeStore().getunReadMsgCount();
                    }
                  } else {
                    $axios
                      .groupread({
                        token: HomeStore().token,
                        group_id: i,
                        readtype: "read",
                      })
                      .then(() => {
                        HomeStore().getunReadMsgCount();
                      });
                    if (HomeStore().visibilityState) {
                      item.isRead = true;
                      item.read = 1;
                    } else {
                      item.read = 0;
                    }
                  }
                  if (!item.reply_id) {
                    HomeStore().chatMessageList[i].push(item);
                    HomeStore().IsSendMessage = true;
                  } else {
                    let MessageIndex = HomeStore().chatMessageList[i].findIndex(
                      (m) => {
                        return m.id == item.reply_id;
                      }
                    );
                    if (MessageIndex != -1) {
                      let huifuIndex = HomeStore().chatMessageList[i][
                        MessageIndex
                      ].replyMessageList.findIndex((reply) => {
                        return reply.id == item.id;
                      });
                      if (huifuIndex == -1) {
                        HomeStore().chatMessageList[i][
                          MessageIndex
                        ].replyMessageList.push(item);
                        let MsgObj = extend(item, true);
                        MsgObj.creator_id = MsgObj.user_id;
                        MsgObj.isRead = true;
                        MsgObj.replyMessageList = [];
                        MsgObj.MainId =
                          HomeStore().chatMessageList[i][MessageIndex].id;
                        MsgObj.Maincontent =
                          HomeStore().chatMessageList[i][MessageIndex].content;
                        MsgObj.Maincreate_time =
                          HomeStore().chatMessageList[i][
                            MessageIndex
                          ].create_time;
                        MsgObj.Maincreator_name =
                          HomeStore().chatMessageList[i][
                            MessageIndex
                          ].creator_name;
                        if (
                          "obj_type" in
                          HomeStore().chatMessageList[i][MessageIndex]
                        ) {
                          MsgObj.obj_type =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].obj_type;
                          MsgObj.obj_val =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].obj_val;
                        }
                        if ("file_path" in item) {
                          MsgObj.Mainfile_path =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].file_path;
                          MsgObj.Mainfile_name =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].file_name;
                          MsgObj.Mainmimetype =
                            HomeStore().chatMessageList[i][
                              MessageIndex
                            ].mimetype;
                        }
                        HomeStore().chatMessageList[i].push(MsgObj);
                        HomeStore().IsSendMessage = true;
                      }
                    }
                  }
                }
              });
            }
          }
        })
        .finally(() => {
          if (this.Timer1) {
            setTimeout(() => {
              this.getMyGroupMsg();
            }, 3000);
          }
        });
    },
    //清除定时器
    clearTimer() {
      this.Timer = "";
      this.Timer1 = "";
    },
    //清空缓存数据
    clearPinia() {
      HomeStore().$reset();
      useDemoStore().$reset();
      HomeStore().isReply = false;
      HomeStore().isDetail = false;
      HomeStore().detailLoading = false;
      HomeStore().sendPopupData = {
        type: "",
      };
      HomeStore().setting.dialogueInfo = {
        type: "",
      };
      HomeStore().conversationObjectList = [];
      HomeStore().menuIndex = -1;
      HomeStore().setting.loading = true;
      HomeStore().setting.loading1 = true;
      HomeStore().SendPopupDataVisible = false;
    },
  },
  beforeUnmount() {
    this.clearPinia();
    this.clearTimer();
  },
};
// 1743585686570296529
</script>
<style lang="less">
@import "./chat.less";
</style>
